import { p as proxyCustomElement, H, c as createEvent } from './p-d7c3b756.js';
import * as _ from 'lodash-es';
import { isEmpty, flatten, isNil, get, cloneDeep, has } from 'lodash-es';
import { h } from './p-06a8959f.js';
import { u as uuidv4 } from './p-2b83a1d1.js';
import { l as createSelector, O as WindowEventMap, w as getKeyboardFocusCSS, F as DEFAULT_FONT, z as BXF_ASSISTIVE_TEXT_HIDDEN, A as BXF_MOUSE_FOCUS, j as getShadowRootElement } from './p-0856cfca.js';
import { B as BxfTypeAheadConstants } from './p-83ac037f.js';
import { F as FocusSource } from './p-462429f0.js';
import { B as BxfButtonSizeEnum } from './p-08621ebf.js';
import { R as Role } from './p-2c2985b9.js';
import { a as BxfProgressIndicatorTypeEnum, B as BxfProgressIndicatorSizeEnum } from './p-d54e51dd.js';
import { e as BxfOverlayTriggerEnum, b as BxfDynamicPositionEnum } from './p-7397c455.js';
import { B as BxfOverlayDropdownController } from './p-dda8e7f3.js';
import { B as BxfPositionConstants, F as FocusTrap } from './p-31d5cbf5.js';
import { g as getParentOverlayContainer } from './p-89fcff47.js';
import { B as BxfTypeAheadUiUtil } from './p-7b9aa141.js';
import { s as sortPredicate, g as getTextWidth, B as BxfSelectKeyDownDelegate } from './p-e2bd7233.js';
import { K as KeyboardEventKey } from './p-b3de3bce.js';
import { a as querySelectorDeep } from './p-37111af4.js';
import { B as BxfTextInputConstants } from './p-57102994.js';
import { a as BxfTypeAheadUtil, b as getTextForResults } from './p-55739fe3.js';
import { B as BxfButtonTypeEnum } from './p-4493a6cc.js';
import { L as LiveRegionPoliteness } from './p-aa4ef7c9.js';
import { i as isRequiredValidator, d as defaultValidator, g as getValidator } from './p-97318b51.js';
import { B as BxfFormValidationType } from './p-4003686b.js';
import { H as HasPopupValue } from './p-74342e6a.js';
import { A as AutocompleteValue } from './p-4e1ff1b5.js';
import { F as FocusIndexManager } from './p-8b298ca7.js';
import { B as BxfDefaultState } from './p-7451d809.js';
import { i as isUsingI18n, B as BxfI18n, t as translateKeys } from './p-01256821.js';

class BxfTypeAheadPillBox {
    delegate;
    isVisibleAlways = false;
    constructor(delegate, isVisibleAlways) {
        this.delegate = delegate;
        this.isVisibleAlways = isVisibleAlways;
        this.clickClearHandler = this.clickClearHandler.bind(this);
        BxfTypeAheadPillBox.init(this.delegate.pillbox);
    }
    static init(pillbox) {
        if (pillbox) {
            pillbox.forEach((pill) => {
                if (!pill.bxfId) {
                    pill.bxfId = uuidv4();
                }
            });
        }
    }
    clickClearHandler(event) {
        const pill = this.delegate.pillbox.find((_pill) => _pill.bxfId === event.target.dataset.bxfId);
        this.removePill(pill);
    }
    removePill(pill) {
        this.delegate.pillbox = this.delegate.pillbox.filter((_pill) => _pill !== pill);
        this.delegate.pillboxChanged.emit({
            srcEvent: null,
            pill,
            type: 'remove',
        });
    }
    static addPill(displayValue, eventData, pillbox, pillboxChanged, hasUniquePills) {
        const pill = {
            bxfId: uuidv4(),
            displayValue,
            eventData,
        };
        if (hasUniquePills && BxfTypeAheadPillBox.contains(pill, pillbox)) {
            return null;
        }
        const event = pillboxChanged.emit({
            srcEvent: null,
            pill,
            type: 'add',
        });
        if (!event.defaultPrevented) {
            return [...pillbox, pill];
        }
        return null;
    }
    static contains(pill, pillbox) {
        return (pillbox.findIndex((_pill) => _pill.displayValue === pill.displayValue) !== -1);
    }
    get containerClasses() {
        const { PILLBOX, PILLBOX_HIDDEN, PILLBOX_ALWAYS_VISIBLE, PILLBOX_SMALL, PILLBOX_LARGE, } = BxfTypeAheadConstants.STRING;
        const pillboxAlwaysVisible = this.isVisibleAlways
            ? PILLBOX_ALWAYS_VISIBLE
            : '';
        const pillboxHidden = this.isVisibleAlways && this.delegate.isOverlayOpen
            ? PILLBOX_HIDDEN
            : '';
        const pillboxSmall = this.delegate.size === 'small' ? PILLBOX_SMALL : '';
        const pillboxLarge = this.delegate.size === 'large' ? PILLBOX_LARGE : '';
        return `${PILLBOX} ${pillboxSmall} ${pillboxLarge} ${pillboxAlwaysVisible} ${pillboxHidden}`;
    }
    get pillboxSize() {
        if (this.delegate.size === 'small') {
            return 'xsmall';
        }
        if (this.delegate.size === 'regular') {
            return 'small';
        }
        return 'large';
    }
    /**
     * The reference should be last in dom props to make sure every prop is set.
     */
    pillRefHandler = (elm) => {
        if (elm) {
            this.delegate.pillDidRender.emit({ value: elm });
        }
    };
    render() {
        if (isEmpty(this.delegate.pillbox))
            return null;
        return (h("div", { class: this.containerClasses }, this.delegate.pillbox.map((pill, index) => {
            const prefix = index < 10 ? '0' : '';
            return (h("bxf-pill", { size: this.pillboxSize, displayValue: pill.displayValue, editInputLabel: pill.editInputLabel, deleteLabel: pill.deleteLabel, lockedLabel: pill.lockedLabel, "data-bxf-id": pill.bxfId, isLocked: pill.isLocked, isDisabled: pill.isDisabled, eventData: pill.eventData, type: pill.type, calendarProps: pill.calendarProps, inlineMenuData: pill.inlineMenuData, ref: this.pillRefHandler, dataTestSuffix: createSelector(`${prefix}${index}`, this.delegate.dataTestSuffix, true), onClickClear: this.clickClearHandler, keepMouseFocus: this.delegate.keepMouseFocus }));
        })));
    }
}

class BxfTypeAheadDropdownInfo {
    delegate;
    _addButton = false;
    constructor(delegate) {
        this.delegate = delegate;
        this.addButtonClickHandler = this.addButtonClickHandler.bind(this);
        this._addButton =
            this.delegate.addButton || this.delegate.addButtonPrime;
    }
    static isVisible(hasInputFocus, isLoading, inputValue, hasMatches, suggestionType, addButtonPrime = false, hasExactMatch = false) {
        const isDisplayable = suggestionType === 'mandatory' &&
            hasInputFocus &&
            !isLoading &&
            !isEmpty(inputValue);
        if (addButtonPrime) {
            return isDisplayable && !hasExactMatch;
        }
        return isDisplayable && !hasMatches;
    }
    isVisible() {
        return BxfTypeAheadDropdownInfo.isVisible(this.delegate.hasInputFocus, this.delegate.isLoading, this.delegate.inputValue, this.delegate.hasMatches, this.delegate.suggestionType, this.delegate.addButtonPrime, this.delegate.hasExactMatch);
    }
    addButtonClickHandler() {
        const event = this.delegate.addClicked.emit({
            srcEvent: null,
            value: this.delegate.inputValue,
        });
        if (this.delegate.pillbox) {
            this.delegate.pillbox = BxfTypeAheadPillBox.addPill(this.delegate.inputValue, undefined, this.delegate.pillbox, this.delegate.pillboxChanged, this.delegate.hasUniquePills);
        }
        if (!event.defaultPrevented) {
            if (this.delegate.focusSource === FocusSource.Mouse ||
                /* istanbul ignore next: touchstart fires mousedown, see ADO-1255700 */ this
                    .delegate.focusSource === FocusSource.Touch) {
                this.delegate.host.blur();
            }
            else {
                this.delegate.inputValue = '';
                this.delegate.focusTextInput();
                this.delegate.isOverlayOpen = false;
            }
        }
    }
    renderAddButtonContainer() {
        return (this._addButton && (h("div", { class: {
                [BxfTypeAheadConstants.STRING.INFO_ADD_BUTTON]: true,
                [BxfTypeAheadConstants.STRING.INFO_ADD_BUTTON_SMALL]: this.delegate.size === 'small',
                [BxfTypeAheadConstants.STRING.INFO_ADD_BUTTON_LARGE]: this.delegate.size === 'large',
                [BxfTypeAheadConstants.STRING.INFO_ADD_BUTTON_PRIME]: this.delegate.addButtonPrime,
                [BxfTypeAheadConstants.STRING
                    .INFO_ADD_BUTTON_PRIME_SMALL]: this.delegate.addButtonPrime &&
                    this.delegate.size === 'small',
                [BxfTypeAheadConstants.STRING
                    .INFO_ADD_BUTTON_PRIME_LARGE]: this.delegate.addButtonPrime &&
                    this.delegate.size === 'large',
            } },
            h("div", { class: BxfTypeAheadConstants.STRING.INFO_ADD_BUTTON_TEXT }, this.delegate.inputValue),
            h("bxf-button", { size: BxfButtonSizeEnum.SMALL, icon: 'add', label: this.delegate.addButtonLabel ||
                    BxfTypeAheadConstants.STRING
                        .ADD_BUTTON_DEFAULT_LABEL, onClick: this.addButtonClickHandler, dataTestSuffix: this.delegate.dataTestSuffix, keepMouseFocus: this.delegate.keepMouseFocus }))));
    }
    renderText() {
        if (!(this.delegate.addButton || this.delegate.addButtonPrime) ||
            this.delegate.addButton ||
            (this.delegate.addButtonPrime && !this.delegate.hasMatches)) {
            return (h("div", { class: BxfTypeAheadConstants.STRING.INFO },
                this.renderDefaultNoResultsMessage(),
                this.renderCustomNoResultsMessage()));
        }
        return null;
    }
    /**
     * Renders the default message in the flyout when no
     * results are found
     */
    renderDefaultNoResultsMessage() {
        if (!this.delegate.customNoResultsMessage) {
            const defaultMessage = [
                h("span", null, "There are no results for "),
                h("div", { class: BxfTypeAheadConstants.STRING.INFO_TEXT_CONTAINER },
                    h("span", null, "\""),
                    h("span", { class: BxfTypeAheadConstants.STRING.INFO_TEXT }, this.delegate.inputValue),
                    h("span", null, "\".")),
            ];
            if (this._addButton) {
                defaultMessage.push(h("div", null, "Would you like to add it?"));
            }
            return defaultMessage;
        }
        return [];
    }
    /**
     * Renders the user-provided message in the flyout when no
     * results are found
     */
    renderCustomNoResultsMessage() {
        return (this.delegate.customNoResultsMessage && (h("span", null, this.delegate.customNoResultsMessage)));
    }
    render() {
        return (this.isVisible && (h("div", { class: BxfTypeAheadConstants.STRING.INFO_CONTAINER },
            this.renderText(),
            this.renderAddButtonContainer())));
    }
}

class BxfTypeAheadDropdownInitialState {
    delegate;
    onClickOption;
    constructor(delegate, onClickOption) {
        this.delegate = delegate;
        this.onClickOption = onClickOption;
        this.onClickOption = this.onClickOption.bind(this);
    }
    static isVisible(inputValue, initialStateData, isLoading) {
        return isEmpty(inputValue) && !isEmpty(initialStateData) && !isLoading;
    }
    isVisible() {
        return BxfTypeAheadDropdownInitialState.isVisible(this.delegate.inputValue, this.delegate.initialStateData, this.delegate.isLoading);
    }
    /**
     * Render initial option as list item
     */
    renderOption(value, groupIndex, optionIndex) {
        return (h("li", { role: Role.NONE },
            h("button", { onClick: this.onClickOption, role: Role.OPTION, "data-bxf-id": value.bxfId, class: `${BxfTypeAheadConstants.STRING.OPTION} ${this.delegate.isCompact
                    ? BxfTypeAheadConstants.STRING.OPTION_COMPACT
                    : ''}`, tabIndex: groupIndex === 0 && optionIndex === 0 ? 0 : -1 },
                h("div", { class: BxfTypeAheadConstants.STRING
                        .OPTION_HIGHLIGHT_CONTAINER }, value.displayValue))));
    }
    renderOptionGroupLabel(optionGroup) {
        return (h("div", { class: `${BxfTypeAheadConstants.STRING.OPTION_GROUP_LABEL} ${this.delegate.isCompact
                ? BxfTypeAheadConstants.STRING
                    .OPTION_GROUP_LABEL_COMPACT
                : ''} ` }, optionGroup.label));
    }
    renderOptionGroup(optionGroup, groupIndex) {
        return (h("li", { role: Role.NONE, class: BxfTypeAheadConstants.STRING
                .CATEGORISED_GROUPED_OPTION_GROUP },
            this.renderOptionGroupLabel(optionGroup),
            h("ul", { role: Role.NONE, class: BxfTypeAheadConstants.STRING.OPTION_GROUP }, optionGroup.values.map((value, index) => this.renderOption(value, groupIndex, index)))));
    }
    render() {
        if (this.isVisible())
            return (h("ul", { class: BxfTypeAheadConstants.STRING.INITIAL_STATE, role: Role.LISTBOX, "aria-label": this.delegate.getListboxLabel() }, this.delegate.initialStateData.map((optionGroup, index) => this.renderOptionGroup(optionGroup, index))));
    }
}

class BxfTypeAheadDropdownLoading {
    delegate;
    constructor(delegate) {
        this.delegate = delegate;
    }
    static isVisible(isLoading) {
        return isLoading;
    }
    isVisible() {
        return BxfTypeAheadDropdownLoading.isVisible(this.delegate.isLoading);
    }
    render() {
        if (!this.isVisible())
            return;
        return (
        // Double div to support margin and border together .bxf-type-ahead__pillbox + * { ... }
        h("div", null,
            h("div", { class: BxfTypeAheadConstants.STRING.LOADING },
                h("bxf-progress-indicator", { loadingLabel: 'Loading', type: BxfProgressIndicatorTypeEnum.LOADING, size: BxfProgressIndicatorSizeEnum.REGULAR, isSpinner: true, hasLabel: true, dataTestSuffix: this.delegate.dataTestSuffix }))));
    }
}

class BxfTypeAheadKeySelection {
    static keySelectionChanged(selection, dropdownContainerRef, isMouse = false) {
        if (!selection)
            return;
        const previousSelection = flatten([
            Array.from(dropdownContainerRef.querySelectorAll(`.${BxfTypeAheadConstants.STRING.OPTION}`)),
            Array.from(dropdownContainerRef.querySelectorAll(`.${BxfTypeAheadConstants.STRING.TABLE_ROW}`)),
        ]);
        previousSelection.forEach((option) => {
            option.tabIndex = -1;
        });
        const selectedOption = dropdownContainerRef.querySelector(`[data-bxf-id="${selection.bxfId}"]`);
        if (!selectedOption)
            return;
        if (selectedOption.offsetTop >
            dropdownContainerRef.scrollTop +
                dropdownContainerRef.offsetHeight ||
            selectedOption.offsetTop < dropdownContainerRef.scrollTop) {
            selectedOption.scrollIntoView({
                block: 'nearest',
                inline: 'nearest',
            });
        }
        selectedOption.tabIndex = 0;
        if (!isMouse) {
            selectedOption.focus();
        }
    }
}

const { BOTTOM_LEFT, TOP_LEFT } = BxfDynamicPositionEnum;
class BxfTypeAheadOverlay {
    componentType;
    delegate;
    overlay;
    containerRef;
    inputRef;
    dropdownContainerRef;
    constructor(componentType, delegate, containerRef, inputRef, dropdownContainerRef) {
        this.componentType = componentType;
        this.delegate = delegate;
        // #region "Bindings"
        this.updateState = this.updateState.bind(this);
        this.shouldOpenCallback = this.shouldOpenCallback.bind(this);
        // #endregion "Bindings"
        // #region "Constructor"
        this.containerRef = containerRef;
        this.inputRef = inputRef;
        this.dropdownContainerRef = dropdownContainerRef;
        // #endregion "Constructor"
        this.inputRef?.addEventListener(WindowEventMap.mousedown, (event) => {
            event.stopPropagation();
        });
        this.dropdownContainerRef?.addEventListener(WindowEventMap.mousedown, (event) => {
            event.preventDefault();
            event.stopPropagation();
        });
        this.outsideOverlayCallback = this.outsideOverlayCallback.bind(this);
        this.init();
    }
    init() {
        this.overlay = new BxfOverlayDropdownController(this.delegate.host, this.containerRef, this.inputRef, this.dropdownContainerRef, this.updateState, this.overlayOptions, this.outsideOverlayCallback);
    }
    /**
     * Outside overlay callback for dropdown controller, depends on component type
     * @returns {boolean}
     */
    outsideOverlayCallback() {
        this.componentType.onOverlayClickedOutside();
        return true;
    }
    get overlayOptions() {
        return {
            skipFocus: true,
            closeOnEscape: false, // handle closing on escape in typeahead instead
            trigger: BxfOverlayTriggerEnum.PRESSED,
            overlaysToClose: this.delegate.shouldCloseOverlays
                ? [BxfPositionConstants.STRING.DROPDOWN_CONTAINER]
                : [],
            modifiers: {
                flipOrder: [BOTTOM_LEFT, TOP_LEFT],
                defaultPlacement: BOTTOM_LEFT,
                isOnCursorPosition: false,
                elementHeightStatus: {
                    originalElementHeight: BxfPositionConstants.STRING.INITIAL_ELEMENT_HEIGHT,
                },
            },
            shouldOpenCallback: this.shouldOpenCallback,
            shouldToggleExpanded: false,
            keepMouseFocus: this.delegate.keepMouseFocus,
            useFocusVisible: true,
            parentContainer: getParentOverlayContainer(this.delegate.parentOverlayContainerSelector),
        };
    }
    /**
     * Returns whether or not overlay open
     */
    isOpen() {
        return this.overlay && this.overlay.isOpen();
    }
    /**
     * Focus first item in overlay source.
     */
    focusFirstItemInOverlay(source = this.overlay.sourceElement) {
        FocusTrap.focusFirstElem(source, false);
    }
    shouldOpenCallback() {
        return !this.delegate.isDisabled;
    }
    updateState(value) {
        if (value && !this.delegate.isReadOnly) {
            this.overlay.openOverlayWithPosition();
            this.setDropdownWidth();
            this.delegate.isOverlayOpen = true;
        }
        else {
            this.delegate.isOverlayOpen = false;
        }
    }
    setDropdownWidth() {
        if (this.dropdownContainerRef && this.inputRef) {
            const dropdownWidth = `${this.determineDropdownWidth()}px`;
            this.dropdownContainerRef.style.width = dropdownWidth;
            this.dropdownContainerRef.style.minWidth = dropdownWidth;
        }
    }
    /**
     * Private method that determines the width of the
     * type-ahead dropdown based on the dropdownOffsetWidth
     * specified (or not) by developers.
     */
    determineDropdownWidth() {
        const overallWidth = this.inputRef?.offsetWidth ?? 0;
        return overallWidth;
    }
    resetDropdownWidth() {
        if (this.dropdownContainerRef) {
            this.dropdownContainerRef.style.width = 'auto';
            this.dropdownContainerRef.style.maxWidth = `${window.innerWidth -
                (this.inputRef?.getBoundingClientRect().left ?? 0) -
                8}px`;
        }
    }
    openDropdown() {
        if (this.overlay && !this.overlay.isOpen()) {
            this.overlay.open();
            this.overlay.updatePosition();
            return true;
        }
        return false;
    }
    closeDropdown(isMouseFocus = false) {
        if (this.overlay && this.overlay.isOpen()) {
            this.overlay.close(isMouseFocus);
            return true;
        }
        return false;
    }
    updatePosition() {
        if (this.overlay && this.overlay.isOpen()) {
            this.overlay.updatePosition();
        }
    }
}

const customWindow = window;
class BxfTypeAheadRegular {
    delegate;
    // Overlay props
    overlay;
    containerRef;
    dropdownContainerRef;
    inputRef;
    liveRegionText = '';
    isDropdownFocused = false;
    constructor(delegate) {
        this.delegate = delegate;
        this.parentRefHandler = this.parentRefHandler.bind(this);
        this.sourceRefHandler = this.sourceRefHandler.bind(this);
        this.inputRefHandler = this.inputRefHandler.bind(this);
        this.inputFocusHandler = this.inputFocusHandler.bind(this);
        this.inputBlurHandler = this.inputBlurHandler.bind(this);
        this.inputClearHandler = this.inputClearHandler.bind(this);
        this.inputFormValueChanged = this.inputFormValueChanged.bind(this);
        this.inputValueChanged = this.inputValueChanged.bind(this);
        this.onClickOption = this.onClickOption.bind(this);
        this.optionRefHandler = this.optionRefHandler.bind(this);
        this.onClickViewAll = this.onClickViewAll.bind(this);
        this.keyDownHandler = this.keyDownHandler.bind(this);
        this.dropdownKeyDownHandler = this.dropdownKeyDownHandler.bind(this);
    }
    componentDidRender() {
        this.initOverlayController();
        if (this.overlay) {
            this.overlay.setDropdownWidth();
            this.overlay.updatePosition();
        }
    }
    optionGroupInfo(optionGroup) {
        let matches = optionGroup.values
            .map((option) => option.bxfMatch)
            .filter((option) => option).length;
        const totalResults = optionGroup.totalResults || matches;
        if (!isNil(get(optionGroup, 'limit')) && matches > optionGroup.limit) {
            matches = optionGroup.limit;
        }
        return { matches, totalResults };
    }
    renderOptionGroupLabelTotalResults(optionGroup) {
        const { matches, totalResults } = this.optionGroupInfo(optionGroup);
        return `(${matches} of ${totalResults})`;
    }
    getOptionGroupId(optionGroup) {
        return `option-group-${optionGroup.bxfId}`;
    }
    renderOptionGroupLabel(optionGroup) {
        return (h("div", { class: `${BxfTypeAheadConstants.STRING.OPTION_GROUP_LABEL} ${this.delegate.isCompact
                ? BxfTypeAheadConstants.STRING
                    .OPTION_GROUP_LABEL_COMPACT
                : ''} `, id: this.getOptionGroupId(optionGroup) },
            `${optionGroup.label} `,
            this.delegate.showResultsCount &&
                this.renderOptionGroupLabelTotalResults(optionGroup)));
    }
    /**
     * Set only first option in dropdown to tabindex=0
     * 	when dropdown navigated to using tab
     */
    resetRovingTabindex() {
        const options = flatten([
            Array.from(this.dropdownContainerRef?.querySelectorAll(`.${BxfTypeAheadConstants.STRING.OPTION}`)),
            Array.from(this.dropdownContainerRef?.querySelectorAll(`.${BxfTypeAheadConstants.STRING.TABLE_ROW}`)),
        ]);
        if (!options)
            return;
        // filter options that have tabindex = 0
        const selectedOptions = options.filter((option) => option.tabIndex === 0);
        if (selectedOptions.length > 1) {
            // only the first option should have tabindex=0, set all others to tabindex=-1
            selectedOptions.slice(1).forEach((option) => {
                option.tabIndex = -1;
            });
        }
    }
    /**
     * Wait for rerender to focus first item in dropdown
     */
    focusFirstItemAfterRerender() {
        const timeout = window.setTimeout(() => {
            this.overlay.focusFirstItemInOverlay(`.${BxfTypeAheadConstants.STRING.DROPDOWN}`);
            this.resetRovingTabindex();
            window.clearTimeout(timeout);
        }, 50);
    }
    /**
     * Open dropdown and focus first element in dropdown on down arrow.
     */
    downArrowHandler(shouldManuallyFocus = this.showDropdownInfo) {
        if (this.overlay && this.overlay.isOpen()) {
            this.isDropdownFocused = true;
            /*
             * let event bubble up to BxfTypeAheadKeySelection if options available
             * otherwise, manually focus first item
             */
            if (shouldManuallyFocus) {
                this.focusFirstItemAfterRerender();
            }
        }
    }
    /**
     * Gets HTML <input> elem inside inputRef.
     */
    getInputElem() {
        const inputRoot = getShadowRootElement(this.inputRef);
        return inputRoot && inputRoot.querySelector('input');
    }
    /**
     * Helper function to focus <input> elem
     */
    focusInput() {
        this.inputRef.focusInput();
    }
    /**
     * Helper function to blur <input> elem
     */
    blurInput() {
        const inputElem = this.getInputElem();
        if (inputElem) {
            inputElem.blur();
        }
    }
    /**
     * Close dropdown and re-focus input when Escape pressed.
     */
    onKeyEscape() {
        this.isDropdownFocused = false;
        this.overlay.closeDropdown();
        this.focusInput();
    }
    handleForwardTabInDropdown(event) {
        // find adjacent focusable element to focus
        const focusTrapContext = customWindow?.activeFocusTrap ?? document.documentElement;
        // get all focusable elements in focusTrapContext
        const focusableElems = FocusTrap.getFocusableElems(focusTrapContext);
        if (!isEmpty(focusableElems)) {
            // get last focusable element in this.inputRef
            const lastFocusable = FocusTrap.lastTabbable(this.inputRef);
            // get index of last focusable element in focusableElems
            const indexOfLastFocusableInInput = focusableElems.indexOf(lastFocusable);
            if (indexOfLastFocusableInInput !== -1) {
                event.preventDefault();
                const nextFocusable = focusableElems[indexOfLastFocusableInInput + 1];
                if (nextFocusable) {
                    event.stopPropagation();
                    nextFocusable.focus();
                }
                else if (customWindow?.activeFocusTrap) {
                    event.stopPropagation();
                    focusableElems[0]?.focus();
                    // check if inputRef is an ancestor of focusableElems[0]
                    const isInputRefAncestor = this.inputRef.contains(focusableElems[0]);
                    this.delegate.hasInputFocus = isInputRefAncestor;
                }
                else {
                    this.delegate.hasInputFocus = false;
                    // HACK: prevent focus from bubbling up to first element to prevent focus trap if typeahead last DOM element
                    document.documentElement.blur();
                }
            }
        }
    }
    onKeyTab(event) {
        const focusableElems = FocusTrap.getFocusableElems(this.dropdownContainerRef);
        if (isEmpty(focusableElems))
            return;
        // get index of focused element in focusableElems
        const focusedElem = FocusTrap.getFocusedElem(this.dropdownContainerRef);
        const focusedIndex = focusableElems.indexOf(focusedElem);
        // Shift+tab should move focus back to last input element ONLY if first elem focused
        // Tab should move focus to next element ONLY if last elem in dropdown focused
        if (event.shiftKey && focusedIndex === 0) {
            this.isDropdownFocused = false;
            this.overlay.closeDropdown(true);
            event.preventDefault();
            event.stopPropagation();
            FocusTrap.focusLastElem(this.inputRef, false);
        }
        else if (!event.shiftKey &&
            focusedIndex === focusableElems.length - 1) {
            this.isDropdownFocused = false;
            this.overlay.closeDropdown(true);
            this.handleForwardTabInDropdown(event);
        }
    }
    /**
     * Handle blur as mouse event when overlay clicked outside.
     */
    onOverlayClickedOutside() {
        this.isDropdownFocused = false;
        this.toggleFocusSource(FocusSource.Mouse);
        this.handleBlur();
    }
    checkLastTabbableInInput(event) {
        const focusedElem = FocusTrap.getFocusedElem(this.inputRef);
        if (focusedElem) {
            const lastFocusable = FocusTrap.lastTabbable(this.inputRef);
            if (focusedElem === lastFocusable) {
                event.preventDefault();
                this.delegate.hasInputFocus = true;
                this.downArrowHandler(true);
            }
        }
    }
    /**
     * Move focus to dropdown if last focusable item inside typeahead input container focused
     */
    tabKeyHandler(event) {
        if (event.shiftKey || !this.overlay?.isOpen())
            return;
        // check if there are any focusable elements in dropdown
        const focusableElems = FocusTrap.getFocusableElems(this.dropdownContainerRef);
        if (isEmpty(focusableElems))
            return;
        event.stopPropagation();
        this.checkLastTabbableInInput(event);
    }
    /**
     * Handle following keyboard events:
     * - Down arrow - go to typeahead listbox
     * - Up arrow - prevent keydown delegate
     * - Escape - close dropdown without closing any other overlays
     * - Tab - move focus to dropdown if last item in input focused
     */
    keyDownHandler(event) {
        switch (event.key) {
            case KeyboardEventKey.ArrowDown:
                this.downArrowHandler();
                break;
            case KeyboardEventKey.ArrowUp:
                event.stopPropagation();
                break;
            case KeyboardEventKey.Escape:
                event.stopPropagation();
                this.onKeyEscape();
                break;
            case KeyboardEventKey.Tab:
                this.tabKeyHandler(event);
                break;
            // no default
        }
    }
    /**
     * Handle following keyboard events:
     * - Down arrow - go to typeahead listbox
     * - Up arrow - prevent keydown delegate
     * - Escape - close dropdown without closing any other overlays
     */
    dropdownKeyDownHandler(event) {
        switch (event.key) {
            case KeyboardEventKey.Escape:
                event.stopPropagation();
                this.onKeyEscape();
                break;
            case KeyboardEventKey.Tab:
                this.onKeyTab(event);
                break;
            // no default
        }
    }
    // #region "Key Selection"
    /**
     * Handle mouse and keyboard selection changes
     */
    keySelectionChanged(selection, isMouse = false) {
        this.toggleFocusSource(isMouse ? FocusSource.Mouse : FocusSource.Keyboard);
        BxfTypeAheadKeySelection.keySelectionChanged(selection, this.dropdownContainerRef, this.isMouseFocus);
    }
    getOptionsFromData() {
        if (!this.delegate?.data) {
            return [];
        }
        return flatten(this.delegate.data.map((optionGroup) => [...optionGroup.values]
            .filter((option) => !this.delegate.filterResults || option.bxfMatch)
            .sort((option1, option2) => this.defaultSort(option1, option2))
            .slice(0, get(optionGroup, 'limit'))));
    }
    // #endregion "Key Selection"
    // #region "Overlay"
    initOverlayController() {
        const inputElement = querySelectorDeep(`.${BxfTextInputConstants.STRING.TEXT_INPUT_INNER_SECTION}`, this.inputRef);
        if (!this.overlay &&
            this.containerRef &&
            this.inputRef &&
            this.dropdownContainerRef) {
            this.overlay = new BxfTypeAheadOverlay(this, this.delegate, this.containerRef, inputElement, this.dropdownContainerRef);
        }
    }
    inputRefHandler(elm) {
        if (elm) {
            this.inputRef = elm;
        }
    }
    parentRefHandler(elm) {
        if (elm) {
            this.containerRef = elm;
        }
    }
    sourceRefHandler(elm) {
        if (elm) {
            this.dropdownContainerRef = elm;
            if (this.delegate.host.dataset.bxfIsNavItem === 'true') {
                elm.classList.add('bxf-theme-light');
            }
        }
    }
    // #endregion "Overlay"
    // #region "Selecting options"
    get currentData() {
        return BxfTypeAheadDropdownInitialState.isVisible(this.delegate.inputValue, this.delegate.initialStateData, this.delegate.isLoading)
            ? this.delegate.initialStateData
            : this.delegate.data;
    }
    eventData(srcEvent, optionGroup, optionGroupIndex, option, _rowIndex = null) {
        return {
            optionGroup: {
                ...optionGroup,
                values: [option],
            },
            option,
            optionGroupIndex,
            searchValue: option.displayValue,
            pillbox: this.delegate.pillbox,
            srcEvent,
            rowIndex: _rowIndex,
        };
    }
    emitTypeaheadSelectionChanged(srcEvent, optionGroup, optionGroupIndex, option, rowIndex) {
        const eventData = this.eventData(srcEvent, optionGroup, optionGroupIndex, option, rowIndex);
        const event = this.delegate.typeaheadSelectionChanged.emit(eventData);
        if (event.defaultPrevented) {
            this.delegate.shouldEmitInputValueChanged = false;
        }
        return event.defaultPrevented;
    }
    /**
     * This method selects an option from the data array.
     * When data has a tabular format (displayed in a table with rows and cells) rowIndex cannot be optional.
     * @see BxfTypeAheadUiUtil.getTableRows
     */
    selectOption(bxfId, event, rowIndex) {
        const data = this.currentData;
        const { option, optionGroup, optionGroupIndex } = BxfTypeAheadUtil.getOptionBranch(bxfId, data);
        if (this.delegate.pillbox) {
            this.addPill(bxfId);
        }
        // Make input changes
        const _isDefaultPrevented = this.emitTypeaheadSelectionChanged(event, optionGroup, optionGroupIndex, option, rowIndex);
        if (this.delegate.pillbox)
            return;
        if (this.delegate.shouldEmitInputValueChanged) {
            this.delegate.inputValueChanged.emit({
                srcEvent: null,
                value: option.displayValue,
            });
        }
        let inputValue = option.displayValue;
        if (this.delegate.clearOnSelection) {
            inputValue = '';
        }
        else if (_isDefaultPrevented) {
            inputValue = this.delegate.inputValue;
        }
        // Pass the value before the debounce/throttle time
        this.delegate.inputValue = inputValue;
        this.inputRef.setValue(inputValue);
        this.delegate.delayedSearch(inputValue);
        if (!this.delegate.isContinuous) {
            // Close the dropdown and blur the host
            if (this.isMouseFocus) {
                this.delegate.host.blur();
            }
            else {
                this.focusInput();
            }
            this.isDropdownFocused = false;
            this.overlay.closeDropdown(this.isMouseFocus);
        }
        else {
            this.focusInput();
        }
    }
    addPill(bxfId) {
        const { option } = BxfTypeAheadUtil.getOptionBranch(bxfId, this.currentData);
        const pillbox = BxfTypeAheadPillBox.addPill(option.displayValue, option.value, this.delegate.pillbox, this.delegate.pillboxChanged, this.delegate.hasUniquePills);
        if (pillbox) {
            this.delegate.pillbox = pillbox;
        }
        if (this.delegate.clearOnSelection) {
            this.delegate.inputValue = '';
            this.delegate.delayedSearch('');
        }
    }
    onClickOption(event) {
        const { bxfId } = event.currentTarget.dataset;
        this.selectOption(bxfId, event);
    }
    optionRefHandler(elm) {
        if (elm) {
            this.delegate.optionDidRender.emit({ srcEvent: null, value: elm });
        }
    }
    // #endregion "Selecting options"
    // #region "Options"
    /**
     * Render typeahead option as list item if they match the search criteria
     */
    renderOption(value) {
        if (!value.bxfMatch && this.delegate.filterResults)
            return null;
        const content = BxfTypeAheadUiUtil.hightlightOption(value, this.delegate.highlightMode);
        return (!!content && (h("li", { role: Role.NONE },
            h("button", { "data-bxf-id": value.bxfId, role: Role.OPTION, class: `${BxfTypeAheadConstants.STRING.OPTION} ${this.delegate.isCompact
                    ? BxfTypeAheadConstants.STRING.OPTION_COMPACT
                    : ''}`, onClick: this.onClickOption, ref: this.optionRefHandler, tabIndex: 0 }, content))));
    }
    renderOptionGroup(optionGroup) {
        const groupedOptions = cloneDeep(optionGroup);
        const sortedOptions = [...groupedOptions.values].sort((option1, option2) => this.defaultSort(option1, option2));
        const options = sortedOptions
            .map((value) => this.renderOption(value))
            .filter(Boolean)
            .slice(0, get(optionGroup, 'limit'));
        return (!isEmpty(options) && (h("div", { class: BxfTypeAheadConstants.STRING.OPTION_GROUP }, options)));
    }
    defaultSort(option1, option2) {
        return sortPredicate(this.delegate.inputValue, option1.displayValue, option2.displayValue);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onClickViewAll(event, _eventData) {
        event.preventDefault();
        if (this.delegate.isDisabled) {
            event.stopPropagation();
        }
        else {
            // Close the dropdown and blur the host
            if (this.isMouseFocus) {
                this.delegate.host.blur();
            }
            else {
                if (this.delegate.suggestionType === 'mandatory') {
                    this.delegate.inputValue = '';
                }
                this.focusInput();
            }
            this.overlay.closeDropdown(this.isMouseFocus);
        }
    }
    renderViewAll(numberOfValues, onClick = this.onClickViewAll) {
        return (h("bxf-button", { label: `${this.delegate.viewAllLabel} ${numberOfValues || ''}`.trim(), type: BxfButtonTypeEnum.TERTIARY, keepMouseFocus: this.delegate.keepMouseFocus, dataTestSuffix: this.delegate.dataTestSuffix, onClick: onClick }));
    }
    // #endregion "Options"
    // #region "Dropdown"
    dropDownCss(pBox, initialState, loading, content) {
        return `${pBox || initialState || loading || content || this.showDropdownInfo
            ? BxfTypeAheadConstants.STRING.DROPDOWN
            : ''}`;
    }
    renderDropdown() {
        const pillBox = this.renderPillBox(false, true);
        const initialState = this.renderInitialState();
        const loading = this.renderLoading();
        const content = this.renderContent();
        const dropdownCss = this.dropDownCss(pillBox, initialState, loading, content);
        const renderDropdownCss = getKeyboardFocusCSS(dropdownCss, this.delegate.keepMouseFocus);
        return (h("div", { ref: this.sourceRefHandler, class: renderDropdownCss, onKeyDown: this.dropdownKeyDownHandler },
            pillBox,
            initialState,
            loading,
            this.delegate.addButtonPrime ? content : this.renderInfo(),
            this.delegate.addButtonPrime ? this.renderInfo() : content));
    }
    renderInitialState() {
        return new BxfTypeAheadDropdownInitialState(this.delegate, this.onClickOption).render();
    }
    renderLoading() {
        return (h("div", { role: Role.STATUS, "aria-live": LiveRegionPoliteness.POLITE, "aria-atomic": 'true' }, new BxfTypeAheadDropdownLoading(this.delegate).render()));
    }
    /**
     * Return whether or not to show dropdown info
     */
    get showDropdownInfo() {
        return BxfTypeAheadDropdownInfo.isVisible(this.delegate.hasInputFocus, this.delegate.isLoading, this.delegate.inputValue, this.delegate.hasMatches, this.delegate.suggestionType, this.delegate.addButtonPrime, this.delegate.hasExactMatch);
    }
    renderInfo() {
        const showDropdownInfo = this.showDropdownInfo;
        return (h("div", { role: Role.STATUS, "aria-live": LiveRegionPoliteness.POLITE, "aria-atomic": 'true', class: {
                [BxfTypeAheadConstants.STRING.INFO_ADD_BUTTON_PRIME_BORDER]: this.delegate.addButtonPrime && showDropdownInfo,
            } }, showDropdownInfo
            ? new BxfTypeAheadDropdownInfo(this.delegate).render()
            : this.delegate.filterResults &&
                !this.delegate.isLoading &&
                this.renderLiveRegionText()));
    }
    /**
     * Calculates the offset (in px) for extra content below the type-ahead input box if the label
     * is positioned to the left
     */
    getOffset() {
        let offset = 0;
        if (this.delegate.isLeftLabel) {
            offset += this.delegate.label
                ? getTextWidth(this.delegate.label, DEFAULT_FONT) + 12
                : 0;
            offset += this.delegate.isRequired
                ? getTextWidth('*', DEFAULT_FONT) + 4
                : 0;
        }
        return offset;
    }
    renderPillBox(isVisibleAlways, isInOverlay) {
        return isInOverlay ? (new BxfTypeAheadPillBox(this.delegate, isVisibleAlways).render()) : (h("div", { style: { marginLeft: `${this.getOffset()}px` } }, new BxfTypeAheadPillBox(this.delegate, isVisibleAlways).render()));
    }
    /**
     * Role for parent dropdown content:
     * 	- Listbox for regular typeahead
     * 	- None for categorized grouped
     */
    getDropdownContentRole() {
        return Role.LISTBOX;
    }
    /**
     * Label for the listbox.
     * 	Null for categorized grouped - there are multiple listboxes in that case
     * @returns {string} The label for the listbox
     */
    getParentListboxLabel() {
        return this.delegate.getListboxLabel();
    }
    isContentVisible() {
        if (this.delegate.isLoading)
            return false;
        const optionGroups = this.delegate.data
            .map((optionGroup) => this.renderOptionGroup(optionGroup))
            .filter(Boolean);
        return (this.delegate.hasMatches &&
            !isEmpty(optionGroups) &&
            !isEmpty(this.delegate.inputValue));
    }
    renderContent() {
        if (this.delegate.isLoading)
            return null;
        const optionGroups = this.delegate.data
            .map((optionGroup) => this.renderOptionGroup(optionGroup))
            .filter(Boolean);
        return (this.isContentVisible() && (h("ul", { role: this.getDropdownContentRole(), "aria-label": this.getParentListboxLabel(), "aria-description": this.delegate.instructionalText ?? null, class: BxfTypeAheadConstants.STRING.DROPDOWN_CONTENT }, optionGroups)));
    }
    // #endregion "Dropdown"
    // #region "Input"
    /**
     * Handle suggestions when input changed
     */
    suggestionTypeInputHandler() {
        const mapDelegateData = (optionGroup) => optionGroup.values.find((option) => option.displayValue === this.delegate.inputValue);
        // Clear input value for mandatory suggestion type
        if (this.delegate.suggestionType === 'mandatory') {
            let hasSelected = flatten(this.delegate.data.map(mapDelegateData)).filter((elm) => !isEmpty(elm)).length > 0;
            if (!hasSelected) {
                hasSelected =
                    flatten(this.delegate.initialStateData.map(mapDelegateData)).filter((elm) => !isEmpty(elm)).length > 0;
            }
            if (!hasSelected) {
                this.delegate.clearInput();
            }
        }
    }
    inputFocusHandler() {
        this.delegate.hasInputFocus = true;
        if (!this.delegate.isReadOnly &&
            (this.delegate.inputValue || this.delegate.initialStateData?.length)) {
            this.overlay.openDropdown();
        }
    }
    /**
     * Handle input blur
     */
    handleBlur() {
        if (!this.delegate.isReadOnly) {
            this.suggestionTypeInputHandler();
            this.delegate.hasInputFocus = false;
            this.overlay.closeDropdown();
            if (!this.delegate.isContinuous) {
                this.delegate.host.blur();
            }
        }
    }
    /**
     * Handle input clear
     */
    inputClearHandler() {
        if (!this.delegate.isReadOnly) {
            this.delegate.clearInput();
        }
    }
    /**
     * Handle input blur if focus did not change to dropdown
     */
    inputBlurHandler() {
        if (!this.isDropdownFocused && !this.delegate.keepMouseFocus) {
            this.handleBlur();
        }
    }
    inputFormValueChanged(event) {
        event.stopPropagation();
    }
    inputValueChanged(event) {
        let { value } = event.detail;
        if (value) {
            value = value.trim();
        }
        this.delegate.inputValueChanged.emit({
            srcEvent: event,
            value: value,
        });
        this.delegate.delayedSearch(value);
        if (value) {
            this.overlay?.openDropdown();
        }
        this.getLiveRegionText();
    }
    /**
     * Updates the live region text.
     * If a debounce time is specified in the delegate, the update is delayed by that amount of time.
     * Otherwise, the update is performed immediately.
     */
    getLiveRegionText() {
        if (this.delegate.debounceTime) {
            setTimeout(() => {
                this.updateLiveRegionText();
            }, this.delegate.debounceTime);
        }
        else {
            this.updateLiveRegionText();
        }
    }
    renderInput() {
        return (h("bxf-text-input", { isLeftLabel: this.delegate.isLeftLabel, isCompact: this.delegate.isCompact, autoFocus: this.delegate.autoFocus, ref: this.inputRefHandler, class: BxfTypeAheadConstants.STRING.INPUT, label: this.delegate.label, instructionalText: this.delegate.instructionalText, assistiveText: this.delegate.assistiveText, autocompleteValue: this.autocompleteVal, hasPopupValue: this.hasPopupVal, isDisabled: this.delegate.isDisabled, isReadOnly: this.delegate.isReadOnly, placeholder: this.delegate.placeholder, size: this.delegate.size, isValid: this.delegate.isValid, validationType: this.delegate.validationType, isRequired: isRequiredValidator(this.delegate.validator) ||
                this.delegate.isRequired, value: this.delegate.inputValue, isTextUpperCase: this.delegate.isTextUpperCase, hasClearButton: true, clearButtonLabel: this.delegate.clearButtonLabel, hasClearButtonOnFocus: true, isSearchBox: this.delegate.isSearchBox, dataTestSuffix: this.delegate.dataTestSuffix, onInputFocus: this.inputFocusHandler, onInputBlur: this.inputBlurHandler, onClearButtonClicked: this.inputClearHandler, onFormValueChanged: this.inputFormValueChanged, onValueChanged: this.inputValueChanged, keepMouseFocus: this.delegate.keepMouseFocus }));
    }
    renderErrorMessage() {
        return (!this.delegate.isValid &&
            this.delegate.errorMessage && (h("span", { style: { marginLeft: `${this.getOffset()}px` }, class: this.delegate.validationType ===
                BxfFormValidationType.ERROR
                ? BxfTypeAheadConstants.STRING.ERROR_MESSAGE
                : BxfTypeAheadConstants.STRING.WARNING_MESSAGE }, this.delegate.errorMessage)));
    }
    /**
     * Render live region for error message
     * NOTE: cannot use aria-describedby as it crosses shadow DOM boundaries
     */
    renderErrorMessageWrapper() {
        return (h("span", { role: Role.ALERT, "aria-atomic": 'true' }, this.renderErrorMessage()));
    }
    /**
     * Whether or not component focused via mouse
     * 	Note: if keepMouseFocus enabled, this always returns false
     */
    get isMouseFocus() {
        return (this.delegate.focusSource === FocusSource.Mouse ||
            /* istanbul ignore next: touchstart fires mousedown, see ADO-1255700 */ this
                .delegate.focusSource === FocusSource.Touch);
    }
    /**
     * Toggle focus source to given value.
     * If value is not keyboard, only change value if keepMouseFocus off
     */
    toggleFocusSource(focusSource) {
        if (focusSource === FocusSource.Keyboard) {
            this.delegate.focusSource = FocusSource.Keyboard;
        }
        else if (!this.delegate.keepMouseFocus) {
            this.delegate.focusSource = focusSource;
        }
    }
    /**
     * Update text of live region with number of matches found
     */
    updateLiveRegionText() {
        this.liveRegionText = getTextForResults(this.getOptionsFromData(), this.delegate.inputValue || '');
    }
    /**
     * Render live region to update screen reader users when results available
     */
    renderLiveRegionText() {
        return (h("div", { class: BXF_ASSISTIVE_TEXT_HIDDEN }, this.liveRegionText));
    }
    /**
     * Focus styling for components inside bxf-type-ahead
     */
    /* istanbul ignore next: unreachable code */
    get focusSourceCss() {
        return `${this.isMouseFocus ? BXF_MOUSE_FOCUS : ''}`;
    }
    // #endregion "Input"
    /**
     * Set aria-haspopup to listbox for input so screen reader users
     * 	know there is a listbox underneath input.
     *  Note that this value is overridden where tables are rendered
     * (e.g. categorised ungrouped, tabular)
     *  @see HasPopupValue
     *  @see BxfTypeAheadCategorisedUngrouped
     */
    get hasPopupVal() {
        if (this.delegate.isReadOnly) {
            return HasPopupValue.FALSE;
        }
        return HasPopupValue.LISTBOX;
    }
    get autocompleteVal() {
        if (this.delegate.isReadOnly) {
            return AutocompleteValue.NONE;
        }
        return AutocompleteValue.LIST;
    }
    render(dataTest) {
        return (h("div", { ref: this.parentRefHandler, class: BxfTypeAheadConstants.STRING.CONTAINER, "data-test": dataTest },
            h("div", { class: BxfTypeAheadConstants.STRING.INPUT_CONTAINER, onKeyDown: this.keyDownHandler },
                this.renderInput(),
                this.renderErrorMessageWrapper(),
                this.renderPillBox(true)),
            this.renderDropdown()));
    }
}

class BxfTypeAheadCategorisedGrouped extends BxfTypeAheadRegular {
    delegate;
    constructor(delegate) {
        super(delegate);
        this.delegate = delegate;
        this.onClickViewAll = this.onClickViewAll.bind(this);
    }
    onClickViewAll(event, eventData) {
        super.onClickViewAll(event);
        if (this.delegate.isDisabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            this.delegate.viewAllClicked.emit({
                srcEvent: event,
                inputValue: this.delegate.inputValue,
                eventData,
                optionGroupIndex: this.delegate.data.findIndex((elm) => elm.bxfId === eventData.bxfId),
            });
        }
    }
    // #region "Dropdown"
    renderViewAll(numberOfValues, onClick, optionGroup) {
        const content = super.renderViewAll(numberOfValues, onClick);
        const { matches, totalResults } = this.optionGroupInfo(optionGroup);
        if (matches === totalResults) {
            return null;
        }
        return (h("li", { role: Role.NONE, class: `${BxfTypeAheadConstants.STRING.GROUPED_VIEW_ALL} ${this.delegate.isCompact
                ? BxfTypeAheadConstants.STRING.GROUPED_VIEW_ALL_COMPACT
                : ''} ` }, content));
    }
    /**
     * Role for parent dropdown content:
     * 	- Listbox for regular typeahead
     * 	- None for categorized grouped
     */
    getDropdownContentRole() {
        return Role.NONE;
    }
    /**
     * Label for the listbox.
     * 	Null for categorized grouped - there are multiple listboxes in that case
     * @returns {string} The label for the listbox
     */
    getParentListboxLabel() {
        return null;
    }
    /**
     * Render an option group as JSX element
     */
    renderOptionGroup(optionGroup) {
        const content = super.renderOptionGroup(optionGroup);
        if (!content) {
            return null;
        }
        return (h("li", { role: Role.NONE, class: BxfTypeAheadConstants.STRING
                .CATEGORISED_GROUPED_OPTION_GROUP },
            this.renderOptionGroupLabel(optionGroup),
            h("ul", { role: Role.LISTBOX, class: BxfTypeAheadConstants.STRING.OPTION_GROUP, "aria-labelledby": this.getOptionGroupId(optionGroup) }, content),
            this.renderViewAll(undefined, (event) => this.onClickViewAll(event, optionGroup), optionGroup)));
    }
}

class BxfTypeAheadCategorisedUngrouped extends BxfTypeAheadRegular {
    delegate;
    constructor(delegate) {
        super(delegate);
        this.delegate = delegate;
        this.onClickOption = this.onClickOption.bind(this);
        this.onRowKeyDown = this.onRowKeyDown.bind(this);
        this.optionRefHandler = this.optionRefHandler.bind(this);
    }
    componentDidRender() {
        super.componentDidRender();
        // #region "Reset dropdown width"
        if (this.delegate.isLoading)
            return;
        if (isEmpty(this.delegate.inputValue))
            return;
        if (!this.delegate.hasMatches)
            return;
        if (this.overlay) {
            this.overlay.resetDropdownWidth();
        }
        // #endregion "Reset dropdown width"
    }
    // #region "Find Matches"
    findMatches() {
        let hasMatches = false;
        const keyColumn = BxfTypeAheadUiUtil.getKeyColumn(this.delegate.data);
        if (keyColumn) {
            keyColumn.values.forEach((option) => {
                option.bxfMatch = BxfTypeAheadUtil.findMatch(this.delegate.matchValue || this.delegate.inputValue, option.displayValue, this.delegate.highlightMode, option.value, this.delegate.ignorePattern);
                if (option.bxfMatch) {
                    hasMatches = true;
                    if (this.delegate.addButtonPrime &&
                        !this.delegate.hasExactMatch) {
                        this.delegate.hasExactMatch =
                            BxfTypeAheadUtil.findMatchExact(this.delegate.matchValue ||
                                this.delegate.inputValue, option.displayValue, option.value, this.delegate.ignorePattern);
                    }
                }
            });
        }
        if (!hasMatches) {
            this.delegate.hasExactMatch = false;
        }
        return hasMatches;
    }
    // #endregion "Find Matches"
    // #region "Selecting options"
    onClickOption(event) {
        const { bxfId } = event.currentTarget.dataset;
        const rowIndex = parseInt(event.currentTarget.dataset.bxfRowMetadata, 10);
        this.selectOption(bxfId, event, rowIndex);
    }
    /**
     * Listen to keyboard events for row:
     * - Enter/Space - treat as click
     */
    onRowKeyDown(event) {
        if (FocusIndexManager.PRESS_KEYS.includes(event.key)) {
            this.onClickOption(event);
        }
    }
    selectOption(bxfId, event, index) {
        let rowIndex = index;
        // rowIndex cannot be null for tabular types
        if (isNil(rowIndex)) {
            const _rowIndex = BxfTypeAheadUiUtil.getTableRows(this.delegate.data).findIndex((row) => row.find((cell) => cell.bxfId === bxfId));
            // If _rowIndex is undefined it means we selected an option from initialStateData
            // In that case, we leave the rowIndex as undefined
            if (_rowIndex > -1) {
                rowIndex = _rowIndex;
            }
        }
        super.selectOption(bxfId, event, rowIndex);
    }
    // #endregion "Selecting options"
    // #region "Key Selection"
    getOptionsFromData() {
        if (isEmpty(this.delegate.data)) {
            return [];
        }
        return flatten(this.delegate.data[0].values
            .filter((option) => option.bxfMatch)
            .slice(0, get(this.delegate.data[0], 'limit')));
    }
    // #endregion "Key Selection"
    // #region "Dropdown"
    totalResults() {
        const keyColumn = BxfTypeAheadUiUtil.getKeyColumn(this.delegate.data);
        let totalResults = 0;
        BxfTypeAheadUiUtil.getTableRows(this.delegate.data).forEach((row) => {
            row.find((cell) => cell.bxfMatch) && (totalResults += 1);
        });
        if (keyColumn) {
            // Do not display if limit is undefined
            // Do not display if limit and total results are equal
            if (isNil(get(keyColumn, 'limit')) ||
                totalResults <= keyColumn.limit) {
                totalResults = undefined;
            }
            // Overwrite with user input
            if (!isNil(keyColumn.totalResults)) {
                totalResults = keyColumn.totalResults;
            }
        }
        else {
            totalResults = undefined;
        }
        return totalResults >= 0 ? totalResults : undefined;
    }
    onClickViewAll(event, _eventData) {
        super.onClickViewAll(event, _eventData);
        if (this.delegate.isDisabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            this.delegate.viewAllClicked.emit({
                srcEvent: event,
                eventData: _eventData,
                inputValue: this.delegate.inputValue,
            });
        }
    }
    renderViewAll(numberOfValues, onClick = this.onClickViewAll) {
        // Allow for "0" which will only render "View All"
        if (numberOfValues === undefined) {
            return null;
        }
        return super.renderViewAll(numberOfValues, onClick);
    }
    renderHeaderCell(label, textAlign = 'left') {
        return (h("th", { class: `${BxfTypeAheadConstants.STRING.TABLE_HEADER_CELL} ${this.delegate.isCompact
                ? BxfTypeAheadConstants.STRING.TABLE_HEADER_CELL_COMPACT
                : ''} `, style: { textAlign } }, label));
    }
    renderHeader() {
        return (h("thead", null,
            h("tr", null, this.delegate.data.map((optionGroup) => this.renderHeaderCell(optionGroup.label, optionGroup.textAlign)))));
    }
    /**
     * Render typeahead suggestion as table cell
     */
    renderCell(cell, match = true) {
        let content;
        if (match) {
            content = BxfTypeAheadUiUtil.hightlightOption(cell, this.delegate.highlightMode);
        }
        const textAlign = has(this.delegate.data[0], 'textAlign')
            ? this.delegate.data[0].textAlign
            : 'left';
        return (h("td", { ref: this.optionRefHandler, role: Role.GRIDCELL, class: `${BxfTypeAheadConstants.STRING.TABLE_CELL} ${this.delegate.isCompact
                ? BxfTypeAheadConstants.STRING.TABLE_CELL_COMPACT
                : ''} `, "data-overflow": String(cell.overflow), style: { textAlign } }, content || cell.displayValue));
    }
    renderRow(row, rowIndex) {
        if (!row[0].bxfMatch) {
            return null;
        }
        return (h("tr", { class: BxfTypeAheadConstants.STRING.TABLE_ROW, "data-bxf-id": row[0].bxfId, "data-bxf-row-metadata": rowIndex, onClick: this.onClickOption, onKeyDown: this.onRowKeyDown, tabIndex: 0 }, row.map((cell, cellIndex) => this.renderCell(cell, cellIndex === 0))));
    }
    renderBody() {
        const keyColumn = BxfTypeAheadUiUtil.getKeyColumn(this.delegate.data);
        return (h("tbody", null, [...BxfTypeAheadUiUtil.getTableRows(this.delegate.data)]
            .sort((row1, row2) => sortPredicate(this.delegate.inputValue, row1[0].displayValue, row2[1].displayValue))
            .map((row, rowIndex) => this.renderRow(row, rowIndex))
            .filter(Boolean)
            .slice(0, get(keyColumn, 'limit'))));
    }
    renderFooter() {
        const content = this.renderViewAll(this.totalResults());
        if (!content) {
            return null;
        }
        return (h("div", { class: BxfTypeAheadConstants.STRING.TABLE_FOOTER }, content));
    }
    renderTable() {
        return (h("table", { class: BxfTypeAheadConstants.STRING.TABLE, role: Role.GRID, "aria-label": this.delegate.getListboxLabel(), "aria-description": this.delegate.instructionalText ?? null },
            this.renderHeader(),
            this.renderBody()));
    }
    renderContent() {
        if (this.delegate.isLoading || !this.delegate.hasMatches) {
            return null;
        }
        return (h("div", { class: BxfTypeAheadConstants.STRING.DROPDOWN_CONTENT },
            this.renderTable(),
            this.renderFooter()));
    }
    /**
     * Set aria-haspopup to GRID for categorized-ungrouped type
     * 	so that screen reader users know that typeahead input has
     * 	grid underneath.
     * @see HasPopupValue
     * @see BxfTypeAheadRegular
     */
    get hasPopupVal() {
        if (this.delegate.isReadOnly) {
            return HasPopupValue.FALSE;
        }
        return HasPopupValue.GRID;
    }
}

class BxfTypeAheadTabular extends BxfTypeAheadCategorisedUngrouped {
    getOptionsFromData() {
        if (isEmpty(this.delegate.data))
            return [];
        if (this.delegate.isCategorizedTabular) {
            return flatten(this.delegate.data?.map((optionGroup) => this.getContent(optionGroup)));
        }
        const keyColumn = BxfTypeAheadUiUtil.getKeyColumn(this.delegate.data);
        return flatten(keyColumn.values
            .filter((option, optionIndex) => {
            const matchOnTheRow = !!this.delegate.data.find((optionGroup) => get(optionGroup.values[optionIndex], 'bxfMatch'));
            return get(option, 'bxfMatch') || matchOnTheRow;
        })
            .slice(0, get(keyColumn, 'limit')));
    }
    renderGroupedViewAll(numberOfValues, onClick, optionGroup) {
        const content = super.renderViewAll(numberOfValues, onClick);
        const { matches, totalResults } = this.optionGroupInfo(optionGroup);
        if (matches === totalResults) {
            return null;
        }
        return h("li", { role: Role.NONE }, content);
    }
    renderTableFooter(optionGroup) {
        const content = this.renderGroupedViewAll(0, (event) => this.onClickViewAll(event, optionGroup), optionGroup);
        if (!content) {
            return null;
        }
        return (h("div", { class: BxfTypeAheadConstants.STRING.TABLE_FOOTER }, content));
    }
    getContent(optionGroup) {
        const groupedOptions = cloneDeep(optionGroup);
        const sortedOptions = [...groupedOptions.values].sort((option1, option2) => this.defaultSort(option1, option2));
        return sortedOptions
            .filter((option) => option.bxfMatch)
            .slice(0, get(optionGroup, 'limit'));
    }
    itemInSet(contentSet, value) {
        for (const item of contentSet) {
            if (item.displayValue === value.displayValue &&
                item?.type === value?.value?.type) {
                return true;
            }
        }
        return false;
    }
    getHeaderMatches(content) {
        const contentSet = new Set(content.map((c) => {
            if (typeof c.value === 'object') {
                return { displayValue: c.displayValue, type: c.value.type };
            }
            else {
                return { displayValue: c.displayValue };
            }
        }));
        return this.delegate.data.filter((item) => item.values.some((value) => this.itemInSet(contentSet, value)) || item.isColumnRequired);
    }
    renderTableHeader(content) {
        const matches = this.getHeaderMatches(content);
        return (h("thead", null,
            h("tr", null, matches.map((match) => this.renderHeaderCell(match.label)))));
    }
    renderOptionGroup(optionGroup) {
        const content = this.getContent(optionGroup);
        if (content.length <= 0) {
            return null;
        }
        return (h("li", { role: Role.NONE, class: BxfTypeAheadConstants.STRING.CATEGORISED_TABLE },
            this.renderOptionGroupLabel(optionGroup),
            h("table", { class: BxfTypeAheadConstants.STRING.TABLE, role: Role.GRID, "aria-labelledby": this.getOptionGroupId(optionGroup) },
                this.renderTableHeader(content),
                this.renderBody(content)),
            this.renderTableFooter(optionGroup)));
    }
    transformMatchIfRequired(match, content) {
        const transformedMatch = [];
        if (match.length < this.getHeaderMatches(content).length) {
            match.forEach((cell) => {
                transformedMatch.push(cell);
                if (has(cell, ['value', 'isCoveredByMe'])) {
                    transformedMatch.push({
                        displayValue: cell.value.isCoveredByMe,
                        value: cell.value.isCoveredByMe,
                    });
                }
                if (has(cell, ['value', 'isCoveredInOrg'])) {
                    transformedMatch.push({
                        displayValue: cell.value.isCoveredInOrg,
                        value: cell.value.isCoveredInOrg,
                    });
                }
            });
            return transformedMatch;
        }
        return match;
    }
    // #region "Dropdown"
    renderRow(row, rowIndex, content = []) {
        if (this.delegate.filterResults && !row.find((cell) => cell.bxfMatch)) {
            return null;
        }
        const match = row.filter((cell) => content
            .map((c) => {
            if (typeof c.value === 'object') {
                return {
                    displayValue: c.displayValue,
                    type: c.value.type,
                };
            }
            else {
                return { displayValue: c.displayValue };
            }
        })
            .some((c) => c.displayValue === cell.displayValue &&
            c.type === cell.value.type));
        const transformedMatch = this.transformMatchIfRequired(match, content);
        if (this.delegate.isCategorizedTabular && !match.length) {
            return null;
        }
        return (h("tr", { class: BxfTypeAheadConstants.STRING.TABLE_ROW, "data-bxf-id": this.delegate.isCategorizedTabular
                ? row.find((cell) => content
                    .map((c) => c.displayValue)
                    .includes(cell.displayValue) ||
                    cell.isColumnRequired)['bxfId']
                : row[BxfTypeAheadUiUtil.getKeyColumnIndex(this.delegate.data)].bxfId, "data-bxf-row-metadata": rowIndex, onClick: this.onClickOption, onKeyDown: this.onRowKeyDown, tabIndex: 0 }, this.delegate.isCategorizedTabular
            ? transformedMatch.map((cell) => this.renderCell(cell))
            : row.map((cell) => this.renderCell(cell))));
    }
    renderContent() {
        if (this.delegate.isLoading || !this.delegate.hasMatches) {
            return null;
        }
        if (!this.delegate.isCategorizedTabular) {
            return super.renderContent();
        }
        const optionGroups = this.delegate.data
            .map((optionGroup) => this.renderOptionGroup(optionGroup))
            .filter((optionGroup) => optionGroup);
        return (h("div", { class: BxfTypeAheadConstants.STRING
                .CATEGORISED_TABLE_DROPDOWN_CONTENT }, optionGroups));
    }
    renderBody(content = []) {
        const keyColumn = BxfTypeAheadUiUtil.getKeyColumn(this.delegate.data);
        return (h("tbody", null, BxfTypeAheadUiUtil.getTableRows(this.delegate.data)
            .map((row, rowIndex) => this.renderRow(row, rowIndex, content))
            .filter((row) => row)
            .slice(0, get(keyColumn, 'limit'))));
    }
}

const bxfTypeAheadCss = "button.sc-bxf-type-ahead:hover,a.sc-bxf-type-ahead:hover,input[type=radio].sc-bxf-type-ahead:hover,input[type=checkbox].sc-bxf-type-ahead:hover,input[type=radio].sc-bxf-type-ahead:checked:hover,input[type=checkbox].sc-bxf-type-ahead:checked:hover,svg.sc-bxf-type-ahead:hover{cursor:pointer}svg[disabled].sc-bxf-type-ahead:hover,button[disabled].sc-bxf-type-ahead:hover,label[disabled].sc-bxf-type-ahead:hover,input[type=checkbox].sc-bxf-type-ahead:disabled:hover,input[type=radio].sc-bxf-type-ahead:disabled:hover,input[type=checkbox].sc-bxf-type-ahead:checked:disabled:hover,input[type=radio].sc-bxf-type-ahead:checked:disabled:hover{cursor:default}.bxf__assistive-text--hidden.sc-bxf-type-ahead{position:absolute !important;left:-625rem;top:auto;width:0.0625rem;height:0.0625rem;overflow:hidden}.oneds-blk-heading-display-1.sc-bxf-type-ahead{font-size:clamp(2.3675rem, 1.3308rem + 4.6074vw, 5.4775rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-display-1.sc-bxf-type-ahead{line-height:1.21}}@media (min-width: 48rem){.oneds-blk-heading-display-1.sc-bxf-type-ahead{line-height:1.2}}@media (min-width: 64rem){.oneds-blk-heading-display-1.sc-bxf-type-ahead{line-height:1.18}}@media (min-width: 90rem){.oneds-blk-heading-display-1.sc-bxf-type-ahead{line-height:1.16}}.oneds-blk-heading-xxl.sc-bxf-type-ahead{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xxl.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xxl.sc-bxf-type-ahead{line-height:1.21}}@media (min-width: 64rem){.oneds-blk-heading-xxl.sc-bxf-type-ahead{line-height:1.2}}@media (min-width: 90rem){.oneds-blk-heading-xxl.sc-bxf-type-ahead{line-height:1.18}}.oneds-blk-heading-xl.sc-bxf-type-ahead{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-xl.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 48rem){.oneds-blk-heading-xl.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 64rem){.oneds-blk-heading-xl.sc-bxf-type-ahead{line-height:1.21}}@media (min-width: 90rem){.oneds-blk-heading-xl.sc-bxf-type-ahead{line-height:1.2}}.oneds-blk-heading-l.sc-bxf-type-ahead{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-l.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-l.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-l.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 90rem){.oneds-blk-heading-l.sc-bxf-type-ahead{line-height:1.21}}.oneds-blk-heading-m.sc-bxf-type-ahead{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-m.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 48rem){.oneds-blk-heading-m.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 64rem){.oneds-blk-heading-m.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 90rem){.oneds-blk-heading-m.sc-bxf-type-ahead{line-height:1.22}}.oneds-blk-heading-s.sc-bxf-type-ahead{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}@media (min-width: 37.5rem){.oneds-blk-heading-s.sc-bxf-type-ahead{line-height:1.24}}@media (min-width: 48rem){.oneds-blk-heading-s.sc-bxf-type-ahead{line-height:1.24}}@media (min-width: 64rem){.oneds-blk-heading-s.sc-bxf-type-ahead{line-height:1.24}}@media (min-width: 90rem){.oneds-blk-heading-s.sc-bxf-type-ahead{line-height:1.23}}.oneds-blk-heading-xs.sc-bxf-type-ahead{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-heading-xxs.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-l.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.27;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-m.sc-bxf-type-ahead{font-size:14px;line-height:1.3;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-eyebrow-s.sc-bxf-type-ahead{font-size:12px;line-height:1.34;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl.sc-bxf-type-ahead{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-bold.sc-bxf-type-ahead{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xl-italic.sc-bxf-type-ahead{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xl-link.sc-bxf-type-ahead{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.4;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-l.sc-bxf-type-ahead{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-bold.sc-bxf-type-ahead{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-l-italic.sc-bxf-type-ahead{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-l-link.sc-bxf-type-ahead{font-size:clamp(1.1313rem, 1.0833rem + 0.213vw, 1.275rem);line-height:1.45;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-bold.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-italic.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-link.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-m-compact.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-bold.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-m-compact-italic.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-m-compact-link.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s.sc-bxf-type-ahead,.bxf-type-ahead__info.sc-bxf-type-ahead,.bxf-type-ahead__info-add-button.sc-bxf-type-ahead,.bxf-type-ahead__info-add-button-large.sc-bxf-type-ahead,.bxf-type-ahead__option-group-label.sc-bxf-type-ahead,.bxf-type-ahead__option.sc-bxf-type-ahead,.bxf-type-ahead__table-cell.sc-bxf-type-ahead,.bxf-type-ahead__table-header-cell.sc-bxf-type-ahead,.bxf-type-ahead__loading.sc-bxf-type-ahead,.bxf-type-ahead__message.sc-bxf-type-ahead,.bxf-type-ahead__message--error.sc-bxf-type-ahead,.bxf-type-ahead__message--warning.sc-bxf-type-ahead{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-bold.sc-bxf-type-ahead,.bxf-type-ahead__info-text.sc-bxf-type-ahead,.bxf-type-ahead__info-add-button-text.sc-bxf-type-ahead,.bxf-type-ahead__option-highlight.sc-bxf-type-ahead{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-italic.sc-bxf-type-ahead{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-link.sc-bxf-type-ahead{font-size:14px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-s-compact.sc-bxf-type-ahead{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-bold.sc-bxf-type-ahead{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-s-compact-italic.sc-bxf-type-ahead{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-s-compact-link.sc-bxf-type-ahead{font-size:14px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs.sc-bxf-type-ahead,.bxf-type-ahead__info-add-button-small.sc-bxf-type-ahead{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-bold.sc-bxf-type-ahead{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-italic.sc-bxf-type-ahead{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-link.sc-bxf-type-ahead{font-size:12px;line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-blk-body-xs-compact.sc-bxf-type-ahead{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-bold.sc-bxf-type-ahead{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif}.oneds-blk-body-xs-compact-italic.sc-bxf-type-ahead{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic}.oneds-blk-body-xs-compact-link.sc-bxf-type-ahead{font-size:12px;line-height:1.25;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline}.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(2.0931rem, 1.3588rem + 3.2639vw, 4.2963rem);line-height:1.22;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-m) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.21}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.2}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.18}}.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead strong.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead em.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h1.sc-bxf-type-ahead a.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(1.8506rem, 1.3444rem + 2.25vw, 3.3694rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-s) 0 var(--oneds-space-fluid-m) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.21}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.2}}.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead strong.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead em.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h2.sc-bxf-type-ahead a.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(1.6363rem, 1.3008rem + 1.4907vw, 2.6425rem);line-height:1.23;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xs) 0 var(--oneds-space-fluid-s) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.22}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.21}}.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead strong.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead em.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h3.sc-bxf-type-ahead a.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(1.4469rem, 1.2383rem + 0.9269vw, 2.0725rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxs) 0 var(--oneds-space-fluid-xs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.23}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.22}}.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead strong.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead em.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h4.sc-bxf-type-ahead a.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(1.2794rem, 1.164rem + 0.513vw, 1.6256rem);line-height:1.24;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:var(--oneds-space-fluid-xxxs) 0 var(--oneds-space-fluid-xxs) 0}@media (min-width: 37.5rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.24}}@media (min-width: 48rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.24}}@media (min-width: 64rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.24}}@media (min-width: 90rem){.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead{line-height:1.23}}.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead strong.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead em.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h5.sc-bxf-type-ahead a.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead strong.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead em.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.25;word-wrap:break-word;font-weight:800;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-xxs)}.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead strong.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead em.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible,.oneds-richTextEditorOutput.sc-bxf-type-ahead h6.sc-bxf-type-ahead a.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead p.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-type-ahead ul.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead ol.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding:0 0 var(--oneds-space-m) var(--oneds-space-m);list-style-type:revert}.oneds-richTextEditorOutput.sc-bxf-type-ahead ul.sc-bxf-type-ahead li.sc-bxf-type-ahead:not(:last-child),.oneds-richTextEditorOutput.sc-bxf-type-ahead ol.sc-bxf-type-ahead li.sc-bxf-type-ahead:not(:last-child){padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-type-ahead strong.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-type-ahead em.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:400;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;font-style:italic;padding-bottom:var(--oneds-space-m)}.oneds-richTextEditorOutput.sc-bxf-type-ahead a.sc-bxf-type-ahead{font-size:clamp(1rem, 1rem + 0vw, 1rem);line-height:1.5;word-wrap:break-word;font-weight:700;font-family:\"BLK Fort\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Helvetica Neue\", sans-serif;text-decoration:underline;color:var(--oneds-text-default);text-decoration:underline;text-decoration-thickness:2px;text-underline-offset:3px;transition:text-decoration 300ms ease-out}.oneds-richTextEditorOutput.sc-bxf-type-ahead .mce-content-body.sc-bxf-type-ahead [data-mce-selected=inline-boundary].sc-bxf-type-ahead{background-clip:content-box}.oneds-richTextEditorOutput.sc-bxf-type-ahead a.sc-bxf-type-ahead:hover,.oneds-richTextEditorOutput.sc-bxf-type-ahead a.sc-bxf-type-ahead:active{text-decoration:underline;text-decoration-thickness:4px;transition:text-decoration 100ms ease-out}.oneds-richTextEditorOutput.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background:var(--oneds-bg-black);color:var(--oneds-text-inverse);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-type-ahead a.sc-bxf-type-ahead{color:var(--oneds-text-inverse)}.oneds-richTextEditorOutput.oneds-bg-black.sc-bxf-type-ahead a.sc-bxf-type-ahead:focus-visible{background:var(--oneds-bg-white);color:var(--oneds-text-default);text-decoration:none;border:none;outline:none;border-radius:0}.oneds-richTextEditorOutput.sc-bxf-type-ahead sub.sc-bxf-type-ahead,.oneds-richTextEditorOutput.sc-bxf-type-ahead sup.sc-bxf-type-ahead{line-height:0}.sc-bxf-type-ahead-h [data-aux-is-filter-bar].sc-bxf-type-ahead .aux-type-ahead__container.sc-bxf-type-ahead{width:100%}.bxf-type-ahead__container.sc-bxf-type-ahead{display:flex}.bxf-type-ahead__input-container.sc-bxf-type-ahead{width:100%}.bxf-type-ahead__dropdown.sc-bxf-type-ahead{border:1px solid #aeaba7;border-bottom:1px solid #ff4713;box-sizing:border-box;border-radius:2px;background-color:#ffffff;box-shadow:0 4px 12px 0 #eae7e1;cursor:default;color:#000000;position:absolute}.bxf-type-ahead__info.sc-bxf-type-ahead,.bxf-type-ahead__loading.sc-bxf-type-ahead{margin:8px;padding:12px;background-color:#f9f7f5;text-align:center;line-height:1.5384615385}.bxf-type-ahead__info-text-container.sc-bxf-type-ahead{display:flex;flex-direction:row;justify-content:center}.bxf-type-ahead__info-text.sc-bxf-type-ahead,.bxf-type-ahead__info-add-button-text.sc-bxf-type-ahead{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.bxf-type-ahead__info-add-button-text.sc-bxf-type-ahead{padding-right:8px}.bxf-type-ahead__dropdown-info-container.sc-bxf-type-ahead{display:flex;flex-direction:column;justify-content:center;align-items:flex-end;align-content:center}.bxf-type-ahead__info-add-button.sc-bxf-type-ahead{display:flex;flex-direction:row;justify-content:space-between;align-items:center;align-content:center;margin:0 8px 8px 8px}.bxf-type-ahead__info-add-button-small.sc-bxf-type-ahead{margin:0 4px 4px 4px}.bxf-type-ahead__info-add-button-large.sc-bxf-type-ahead{margin:0 12px 12px 12px}.bxf-type-ahead__info-add-button-prime.sc-bxf-type-ahead{margin-top:8px}.bxf-type-ahead__info-add-button-prime--small.sc-bxf-type-ahead{margin-top:4px}.bxf-type-ahead__info-add-button-prime--large.sc-bxf-type-ahead{margin-top:12px}.bxf-type-ahead__info-add-button-prime-border.sc-bxf-type-ahead{border-top:1px solid #aeaba7}.bxf-type-ahead__option-group.sc-bxf-type-ahead{list-style:none;padding:0;margin:0}.bxf-type-ahead__categorised-grouped-option-group.sc-bxf-type-ahead{margin:4px 0 0 0;padding:0;list-style:none;border-top:1px solid #d9d6ce}.bxf-type-ahead__categorised-grouped-option-group.sc-bxf-type-ahead:first-child{border-top:none;margin-top:0}.bxf-type-ahead__option-group-label.sc-bxf-type-ahead{color:#6b6a67;line-height:1.2307692308;padding:12px}.bxf-type-ahead__option-group-label--compact.sc-bxf-type-ahead{padding:4px 12px}.bxf-type-ahead__option.sc-bxf-type-ahead{display:flex;flex-direction:row;align-items:center;align-content:center;height:2rem;width:100%;background-color:transparent;border:none;text-align:left;padding:0 12px;line-height:1.2307692308;color:#000000;outline-offset:-0.125rem}.bxf-type-ahead__option.sc-bxf-type-ahead:hover{cursor:pointer}.bxf-type-ahead__option.sc-bxf-type-ahead:focus{outline:0.0625rem dotted #ff4713;outline:auto #ff4713}.bxf-type-ahead__option.bxf__focus--keyboard-only.sc-bxf-type-ahead:focus:not(:focus-visible){outline:0}.bxf-type-ahead__option--compact.sc-bxf-type-ahead{height:1.25rem}.bxf-type-ahead__option.sc-bxf-type-ahead:hover{background-color:#ff471312}.bxf-type-ahead__categorised-table.sc-bxf-type-ahead{width:100%;border-collapse:collapse;padding-bottom:2.5rem}.bxf-type-ahead__categorised-table.sc-bxf-type-ahead:last-child{padding-bottom:1rem}.bxf-type-ahead__option-highlight.sc-bxf-type-ahead{background-color:transparent;color:inherit}.bxf-type-ahead__option-highlight-container.sc-bxf-type-ahead{width:100%;text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.bxf-type-ahead__table-footer.sc-bxf-type-ahead{margin-top:4px;padding:12px}.bxf-type-ahead__table-cell.sc-bxf-type-ahead,.bxf-type-ahead__table-header-cell.sc-bxf-type-ahead{padding-left:12px;padding-right:12px;border-bottom:1px solid #d9d6ce;line-height:1.2307692308;height:2rem;color:#000000;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bxf-type-ahead__table-cell--compact.sc-bxf-type-ahead{height:1.25rem}.bxf-type-ahead__table-cell[data-overflow=false].sc-bxf-type-ahead,[data-overflow=false].bxf-type-ahead__table-header-cell.sc-bxf-type-ahead{max-width:0}.bxf-type-ahead__table-header-cell.sc-bxf-type-ahead{overflow:initial;max-width:100%;color:#6b6a67}.bxf-type-ahead__table-header-cell--compact.sc-bxf-type-ahead{height:1.25rem}.bxf-type-ahead__table.sc-bxf-type-ahead{width:100%;border-collapse:collapse}.bxf-type-ahead__table-row.sc-bxf-type-ahead{outline-offset:-0.125rem}.bxf-type-ahead__table-row.sc-bxf-type-ahead:focus{outline:0.0625rem dotted #ff471312;outline:auto #ff471312}.bxf-type-ahead__table-row.bxf__focus--keyboard-only.sc-bxf-type-ahead:focus:not(:focus-visible){outline:0}.bxf-type-ahead__table-row.sc-bxf-type-ahead:hover{background-color:#ff471312}.bxf-type-ahead__pillbox--hidden.sc-bxf-type-ahead{visibility:hidden}.bxf-type-ahead__pillbox.sc-bxf-type-ahead{padding-top:4px;padding-bottom:12px;padding-right:12px;padding-left:12px}.bxf-type-ahead__pillbox.sc-bxf-type-ahead+*.sc-bxf-type-ahead{border-top:1px solid #d9d6ce}.bxf-type-ahead__pillbox.sc-bxf-type-ahead bxf-pill.sc-bxf-type-ahead{display:inline-block;padding-top:8px;padding-right:8px}.bxf-type-ahead__pillbox.sc-bxf-type-ahead bxf-pill.sc-bxf-type-ahead:last-child{padding-right:initial}.bxf-type-ahead__pillbox-small.sc-bxf-type-ahead{padding-top:4px;padding-bottom:8px;padding-right:8px;padding-left:8px}.bxf-type-ahead__pillbox-small.sc-bxf-type-ahead bxf-pill.sc-bxf-type-ahead{padding-top:4px;padding-right:4px}.bxf-type-ahead__pillbox-large.sc-bxf-type-ahead{padding-top:12px;padding-bottom:16px;padding-right:16px;padding-left:16px}.bxf-type-ahead__pillbox-large.sc-bxf-type-ahead bxf-pill.sc-bxf-type-ahead{padding-top:12px;padding-right:12px}.bxf-type-ahead__pillbox-always-visible.sc-bxf-type-ahead{border:1px solid transparent;padding-bottom:initial}.bxf-type-ahead__dropdown-content.sc-bxf-type-ahead,.bxf-type-ahead__categorised-table-dropdown-content.sc-bxf-type-ahead{width:100%;overflow:auto;list-style:none;margin:0;max-height:15.625rem;padding:4px 0}.bxf-type-ahead__grouped-view-all.sc-bxf-type-ahead{padding:12px}.bxf-type-ahead__grouped-view-all--compact.sc-bxf-type-ahead{padding:0 12px}.bxf-type-ahead__categorised-table-dropdown-content.sc-bxf-type-ahead{max-height:21.875rem}.bxf-type-ahead__initial-state.sc-bxf-type-ahead{margin:0;padding:0;max-height:15.625rem;height:100%;overflow:hidden;overflow-y:auto}.bxf-type-ahead__message.sc-bxf-type-ahead,.bxf-type-ahead__message--warning.sc-bxf-type-ahead,.bxf-type-ahead__message--error.sc-bxf-type-ahead{display:block;line-height:1.2307692308;padding-top:4px}.bxf-type-ahead__message--error.sc-bxf-type-ahead{color:#c00b28}.bxf-type-ahead__input.sc-bxf-type-ahead{display:block}@media (forced-colors: active){.bxf-type-ahead__option-highlight.sc-bxf-type-ahead{color:CanvasText;background:none}}@media (forced-colors: active){.bxf-type-ahead__pillbox-always-visible.sc-bxf-type-ahead{border-top-color:Canvas}}";
const BxfTypeAheadStyle0 = bxfTypeAheadCss;

const BxfTypeAhead$1 = /*@__PURE__*/ proxyCustomElement(class BxfTypeAhead extends H {
    constructor() {
        super();
        this.__registerHost();
        this.dropdownOpened = createEvent(this, "dropdownOpened", 7);
        this.dropdownClosed = createEvent(this, "dropdownClosed", 7);
        this.typeaheadValueChanged = createEvent(this, "typeaheadValueChanged", 7);
        this.inputValueChanged = createEvent(this, "inputValueChanged", 7);
        this.typeaheadSelectionChanged = createEvent(this, "typeaheadSelectionChanged", 7);
        this.viewAllClicked = createEvent(this, "viewAllClicked", 7);
        this.addClicked = createEvent(this, "addClicked", 7);
        this.pillboxChanged = createEvent(this, "pillboxChanged", 7);
        this.optionDidRender = createEvent(this, "optionDidRender", 7);
        this.pillDidRender = createEvent(this, "pillDidRender", 7);
        this.formValueChanged = createEvent(this, "formValueChanged", 7);
        this.overlayClickedOutside = createEvent(this, "overlayClickedOutside", 7);
        this.isLeftLabel = false;
        this.autoFocus = false;
        this.isContinuous = false;
        this.ignorePattern = undefined;
        this.isOpen = false;
        this.isLoading = false;
        this.validator = undefined;
        this.type = 'regular';
        this.label = undefined;
        this.instructionalText = undefined;
        this.isCompact = BxfDefaultState.isCompact;
        this.isCategorizedTabular = false;
        this.assistiveText = '';
        this.keepMouseFocus = false;
        this.highlightMode = 'popular';
        this.data = [];
        this.initialStateData = [];
        this.pillbox = undefined;
        this.hasUniquePills = false;
        this.addButton = false;
        this.addButtonLabel = undefined;
        this.addButtonPrime = false;
        this.showResultsCount = true;
        this.size = 'regular';
        this.debounceTime = undefined;
        this.throttleTime = undefined;
        this.filterResults = true;
        this.isDisabled = false;
        this.isReadOnly = false;
        this.isRequired = false;
        this.errorMessage = null;
        this.validationType = BxfFormValidationType.ERROR;
        this.isValid = true;
        this.isTextUpperCase = false;
        this.placeholder = undefined;
        this.inputValue = '';
        this.matchValue = undefined;
        this.shouldCloseOverlays = true;
        this.suggestionType = 'mandatory';
        this.dropdownOffsetWidth = 0;
        this.clearOnSelection = false;
        this.isTracking = true;
        this.trackingData = undefined;
        this.parentOverlayContainerSelector = 'body';
        this.dataTestSuffix = undefined;
        this.isSearchBox = false;
        this.customNoResultsMessage = undefined;
        this.clearButtonLabel = BxfTextInputConstants.STRING.CLEAR_BUTTON_LABEL;
        this.namespaceI18n = undefined;
        this.i18nKeys = undefined;
        this.componentType = undefined;
        this.hasInputFocus = false;
        this.hasMatches = false;
        this.hasExactMatch = false;
        this.isOverlayOpen = false;
        this.focusSource = FocusSource.Keyboard;
    }
    shouldListenForKeyDown = false;
    options;
    keydownDelegate;
    _validator = defaultValidator;
    i18n;
    viewAllLabel = 'View all';
    delayedSearch;
    shouldEmitInputValueChanged = true;
    get host() { return this; }
    // #endregion "Props"
    // #region "Events"
    /**
     * This event is emitted when popover overlay is opened
     */
    dropdownOpened;
    /**
     * This event is emitted when popover overlay is closed
     */
    dropdownClosed;
    /**
     * An event that is triggered on every value change emitted by the input on key press.
     * The event is affected by the debounce or throttle time.
     */
    typeaheadValueChanged;
    /**
     * An event that is triggered on every value change emitted by the input on key press.
     * The event is NOT affected by the debounce or throttle time.
     */
    inputValueChanged;
    /**
     * An event that is triggered when the user selects an option via click or enter.
     * Calling `event.preventDefault()` will prevent the type-ahead from being populated with the selected `option.displayValue`.
     */
    typeaheadSelectionChanged;
    /**
     * An event that is triggered when the user clicks on a view all link.
     */
    viewAllClicked;
    /**
     * An event that is triggered when the user clicks on the add button.
     * Calling `event.preventDefault()` will keep the dropdown opened when clicking the add button.
     */
    addClicked;
    /**
     * Coming from bxf-pillbox
     * An event that is triggered when the user adds or removes a pill.
     */
    pillboxChanged;
    /**
     * An event that is triggered when the option cell is rendered.
     */
    optionDidRender;
    /**
     * An event that is triggered when the pill is rendered.
     */
    pillDidRender;
    /**
     * An event that is triggered when using this component in forms.
     */
    formValueChanged;
    /**
     * Triggered when click outside overlay
     */
    overlayClickedOutside;
    // #endregion "State"
    // #region "Methods"
    /**
     * This method opens the dropdown of the this component.
     * @returns {Promise<void>}
     */
    async open() {
        if (this.data && this.data.length > 0) {
            this.isOpen = true;
        }
    }
    /**
     * This method closes the dropdown of this component.
     * @returns {Promise<void>}
     */
    async close() {
        this.isOpen = false;
    }
    /**
     * Used to toggle disabled state for forms
     * @returns {Promise<void>}
     * @param action controls disable state for text input
     */
    async toggleDisable(action) {
        this.isDisabled = action;
    }
    /**
     * Public method gets validator and sets isValid and errorMessage
     * @returns {Promise<void>}
     */
    async validate() {
        if (this.validator || this.isRequired) {
            this._validator = getValidator(this.validator);
            if (this.pillbox === undefined) {
                this.isValid = this._validator.validate(this.inputValue);
            }
            else {
                this.isValid = this._validator.validate(this.pillbox);
            }
            this.errorMessage = this._validator.errorMessage;
        }
    }
    /**
     * Sets the value of the component by passing a BxfTypeAheadFormValue
     * @param newValue The value to be set.
     */
    async setValue(newValue) {
        if (newValue) {
            // Setting the data
            if (newValue.data === null) {
                this.data = undefined;
            }
            else if (newValue.data !== undefined) {
                this.data = newValue.data;
            }
            // Setting the pillbox
            if (newValue.pillbox === null) {
                this.pillbox = [];
            }
            else if (newValue.pillbox !== undefined) {
                this.pillbox = newValue.pillbox;
            }
            else {
                // Setting the option
                if (newValue.inputValue !== undefined) {
                    this.inputValue = _.get(newValue, 'inputValue', '');
                }
                // Hiding the dropdown using interface value
                if (this.inputValue.trim() === '') {
                    this.componentType.overlay.closeDropdown();
                }
            }
        }
        else {
            this.inputValue = '';
            if (this.pillbox !== undefined) {
                this.pillbox = [];
            }
            this.componentType.overlay.closeDropdown();
        }
    }
    /**
     * Returns whether or not text input has value used for required validation in forms.
     * @returns {Promise<boolean>}
     */
    async validateForRequired(newValue) {
        let isInvalid = false;
        if (typeof newValue === 'string') {
            if (this.pillbox === undefined) {
                isInvalid = _.isEmpty(this.inputValue);
            }
            else {
                isInvalid = _.isEmpty(this.pillbox);
            }
            return Promise.resolve(isInvalid);
        }
        if (_.get(newValue, 'pillbox') === undefined) {
            isInvalid = _.isEmpty(_.get(newValue, 'inputValue'));
        }
        else {
            isInvalid = _.isEmpty(_.get(newValue, 'pillbox'));
        }
        return Promise.resolve(isInvalid); // should return true if value is not provided and required validator should return error
    }
    /**
     * This method allows for focusing on the component's text input element
     */
    async focusInput() {
        this.focusTextInput();
    }
    // #endregion "Methods"
    // #region "Watchers"
    addButtonPrimeChanged(newValue) {
        if (newValue) {
            this.addButton = false;
        }
    }
    isOpenChanged(newValue) {
        if (newValue) {
            this.componentType.overlay.openDropdown();
        }
        else {
            this.componentType.overlay.closeDropdown();
        }
    }
    isOverlayOpenChanged() {
        this.shouldListenForKeyDown = this.isOverlayOpen;
        this.keydownDelegate.didChangeVisibility(!this.shouldListenForKeyDown);
        this.updateKeydownOptions();
        if (this.isOverlayOpen) {
            this.isOpen = true;
            this.dropdownOpened.emit({ srcEvent: null });
        }
        else {
            this.isOpen = false;
            this.dropdownClosed.emit({ srcEvent: null });
        }
    }
    hasInputFocusChangedHandler() {
        if (this.hasInputFocus) {
            this.findMatches();
        }
        if (!this.hasInputFocus) {
            this.validate();
        }
    }
    dataChangedHandler(newValue, oldValue) {
        if (!this.data) {
            this.data = [];
            return;
        }
        BxfTypeAheadUtil.initIds(this.data);
        if (!_.isEqual(oldValue, newValue) && !_.isEmpty(this.data)) {
            this.findMatches();
        }
    }
    initialStateDataChangedHandler() {
        if (!this.initialStateData) {
            this.initialStateData = [];
            return;
        }
        BxfTypeAheadUtil.initIds(this.initialStateData);
    }
    pillboxChangedHandler() {
        BxfTypeAheadPillBox.init(this.pillbox);
        this.formValueChangedHandler();
        this.validate();
    }
    initDelayedSearch() {
        this.delayedSearchHandler = this.delayedSearchHandler.bind(this);
        if (this.debounceTime !== undefined) {
            this.delayedSearch = _.debounce(this.delayedSearchHandler, this.debounceTime);
        }
        else if (this.throttleTime !== undefined) {
            this.delayedSearch = _.throttle(this.delayedSearchHandler, this.throttleTime);
        }
        else {
            this.delayedSearch = this.delayedSearchHandler;
        }
        this.delayedSearch = this.delayedSearch.bind(this);
    }
    // #endregion "Watchers"
    // #region "Lifecycle"
    componentWillLoad() {
        this.addButtonPrimeChanged(this.addButtonPrime);
        /* istanbul ignore else */
        if (isUsingI18n() && this.namespaceI18n) {
            this.initI18n();
        }
        this.initType();
        this.initDelayedSearch();
        this.initKeydownDelegate();
        this.initValidators();
    }
    componentDidRender() {
        if (this.componentType.componentDidRender) {
            this.componentType.componentDidRender();
        }
        this.updateKeydownOptions();
    }
    connectedCallback() {
        this.componentWillLoad();
    }
    disconnectedCallback() {
        this.i18n?.destroyTranslations();
        if (this.componentType && this.componentType.overlay) {
            this.componentType.overlay.closeDropdown();
        }
    }
    // #endregion "Lifecycle"
    initI18n() {
        this.i18n = new BxfI18n(this.namespaceI18n);
        window['i18n'].on('languageChanged', () => {
            this.i18n.languageChangedHandler(this.translateText());
        });
        window['i18n'].on('loaded', () => {
            this.translateText();
        });
    }
    translateText() {
        translateKeys(this, this.i18nKeys, this.i18n);
        this.initialStateData?.forEach((initData) => {
            this.translateContent(initData);
        });
        this.data?.forEach((data) => {
            this.translateContent(data);
        });
        if (this.pillbox) {
            this.translatePillbox(this.pillbox);
        }
    }
    translateContent(typeAheadData) {
        translateKeys(this, this.i18nKeys, this.i18n);
        if (typeAheadData?.label) {
            typeAheadData.label = typeAheadData.i18nKeys?.label
                ? this.i18n.getTranslation(typeAheadData.i18nKeys.label)
                : typeAheadData.label;
        }
        if (typeAheadData?.values) {
            this.translateValues(typeAheadData.values);
        }
    }
    translatePillbox(pillbox) {
        pillbox?.forEach((pill) => {
            pill.inlineMenuData?.forEach((inlineMenuData) => {
                this.translateInlineMenuData(inlineMenuData);
            });
            translateKeys(pill, pill.i18nKeys, this.i18n);
        });
    }
    translateInlineMenuData(inlineMenuData) {
        inlineMenuData?.forEach((element) => {
            element.flyoutData?.forEach((item) => {
                this.translateInlineMenuData(item);
            });
            translateKeys(element, element.i18nKeys, this.i18n);
        });
    }
    translateValues(values) {
        values.forEach((element) => {
            if (element.displayValue) {
                element.displayValue = element.i18nKeys?.displayValue
                    ? this.i18n.getTranslation(element.i18nKeys.displayValue)
                    : element.displayValue;
            }
            if (element.value) {
                element.value = element.i18nKeys?.value
                    ? this.i18n.getTranslation(element.i18nKeys.value)
                    : element.value;
            }
        });
    }
    /**
     * Get appropriate label for listbox for screen readers
     */
    /* istanbul ignore next: unused code */
    get baseLabel() {
        return this.label || this.assistiveText;
    }
    // #region "Select key down delegate interface"
    initKeydownDelegate() {
        this.keydownDelegate = new BxfSelectKeyDownDelegate(this);
        BxfTypeAheadUtil.initIds(this.data);
        BxfTypeAheadUtil.initIds(this.initialStateData);
    }
    updateKeydownOptions() {
        // Clear all selections
        if (BxfTypeAheadDropdownLoading.isVisible(this.isLoading) ||
            BxfTypeAheadDropdownInfo.isVisible(this.hasInputFocus, this.isLoading, this.inputValue, this.hasMatches, this.suggestionType, this.addButtonPrime, this.hasExactMatch)) {
            this.options = [];
            return;
        }
        if (BxfTypeAheadDropdownInitialState.isVisible(this.inputValue, this.initialStateData, this.isLoading)) {
            this.options = _.flatten(this.initialStateData.map((optionGroup) => optionGroup.values.slice(0, _.get(optionGroup, 'limit'))));
        }
        else {
            this.options = this.componentType.getOptionsFromData();
        }
    }
    onKeySelectionChange(selection, isMouse = false) {
        this.componentType.keySelectionChanged(selection, isMouse);
    }
    onKeySelection(selection, event) {
        this.componentType.selectOption(selection.bxfId, event);
    }
    onKeyEscape() {
        this.componentType.onKeyEscape();
    }
    // #endregion "Select key down delegate interface"
    // #region "Find matches"
    /**
     * Finds matches for the input value within the data array.
     *
     * This method iterates through the data array and checks each option's display value
     * against the current input value or match value. It sets the `bxfMatch` property on
     * each option if a match is found. It also updates the `hasMatches` and `hasExactMatch`
     * state properties based on the results.
     *
     * @returns {void}
     */
    findMatches() {
        let hasMatches = false;
        if (this.componentType.delegate.type !== 'tabular' && this.hasMatches) {
            this.hasMatches = hasMatches ?? true;
            this.findMatches(); //recursive call to find matches
        }
        else {
            this.hasMatches = this.getMatchData(hasMatches);
            hasMatches = this.hasMatches;
        }
        if (!hasMatches) {
            this.hasExactMatch = false;
        }
    }
    getMatchData(hasMatches) {
        let _hasMatches = hasMatches;
        this.data.forEach((optionGroup) => optionGroup.values.forEach((option) => {
            option.bxfMatch = BxfTypeAheadUtil.findMatch(this.matchValue || this.inputValue, option.displayValue, this.highlightMode, option.value, this.ignorePattern);
            if (option.bxfMatch) {
                _hasMatches = true;
                if (this.addButtonPrime && !this.hasExactMatch) {
                    this.hasExactMatch = BxfTypeAheadUtil.findMatchExact(this.matchValue || this.inputValue, option.displayValue, option.value, this.ignorePattern);
                }
            }
        }));
        this.hasMatches = !this.filterResults || _hasMatches;
        return _hasMatches;
    }
    delayedSearchHandler(inputValue) {
        this.inputValue = inputValue;
        this.findMatches();
        this.updateKeydownOptions();
        this.validate();
        if (this.shouldEmitInputValueChanged) {
            this.typeaheadValueChanged.emit({
                srcEvent: null,
                value: inputValue,
            });
            this.formValueChangedHandler();
        }
        else {
            this.shouldEmitInputValueChanged = true;
        }
    }
    // #endregion "Find matches"
    // #region "Validator"
    formValueChangedHandler() {
        this.formValueChanged.emit({
            value: {
                inputValue: this.inputValue,
                data: this.data,
                pillbox: this.pillbox,
            },
        });
    }
    initValidators() {
        if (this.validator) {
            this._validator = getValidator(this.validator);
            if (!_.isEmpty(this.inputValue)) {
                this.validate();
            }
        }
    }
    // #endregion "Validator"
    clearInput() {
        this.inputValue = '';
        this.validate();
        this.formValueChangedHandler();
    }
    /**
     * Restores keyboard focus to text input.
     */
    focusTextInput() {
        if (this.componentType.focusInput) {
            this.componentType.focusInput();
        }
    }
    /**
     * Get accessible name for dropdown listbox/grid based on the
     * 	text box's accessible name (comes from label if provided,
     * 	assistiveText if not provided)
     */
    getListboxLabel() {
        return this.label ? this.label : this.assistiveText;
    }
    initType() {
        if (this.type === 'regular') {
            this.componentType = new BxfTypeAheadRegular(this);
        }
        if (this.type === 'categorised-grouped') {
            this.componentType = new BxfTypeAheadCategorisedGrouped(this);
        }
        if (this.type === 'categorised-ungrouped') {
            this.componentType = new BxfTypeAheadCategorisedUngrouped(this);
        }
        if (this.type === 'tabular') {
            this.componentType = new BxfTypeAheadTabular(this);
        }
        if (!this.componentType) {
            throw new Error(`The attribute type="${this.type}" is incorrect or incompatible with this component.`);
        }
    }
    render() {
        return this.componentType.render(createSelector(this.host.tagName, this.dataTestSuffix));
    }
    static get watchers() { return {
        "addButtonPrime": ["addButtonPrimeChanged"],
        "isOpen": ["isOpenChanged"],
        "isOverlayOpen": ["isOverlayOpenChanged"],
        "hasInputFocus": ["hasInputFocusChangedHandler"],
        "data": ["dataChangedHandler"],
        "initialStateData": ["initialStateDataChangedHandler"],
        "pillbox": ["pillboxChangedHandler"],
        "debounceTime": ["initDelayedSearch"],
        "throttleTime": ["initDelayedSearch"]
    }; }
    static get style() { return BxfTypeAheadStyle0; }
}, [2, "bxf-type-ahead", {
        "isLeftLabel": [516, "is-left-label"],
        "autoFocus": [516, "auto-focus"],
        "isContinuous": [516, "is-continuous"],
        "ignorePattern": [16],
        "isOpen": [1540, "is-open"],
        "isLoading": [516, "is-loading"],
        "validator": [16],
        "type": [513],
        "label": [513],
        "instructionalText": [513, "instructional-text"],
        "isCompact": [516, "is-compact"],
        "isCategorizedTabular": [516, "is-categorized-tabular"],
        "assistiveText": [1, "assistive-text"],
        "keepMouseFocus": [4, "keep-mouse-focus"],
        "highlightMode": [513, "highlight-mode"],
        "data": [1040],
        "initialStateData": [1040],
        "pillbox": [1040],
        "hasUniquePills": [516, "has-unique-pills"],
        "addButton": [1540, "add-button"],
        "addButtonLabel": [1, "add-button-label"],
        "addButtonPrime": [516, "add-button-prime"],
        "showResultsCount": [516, "show-results-count"],
        "size": [513],
        "debounceTime": [2, "debounce-time"],
        "throttleTime": [2, "throttle-time"],
        "filterResults": [516, "filter-results"],
        "isDisabled": [1540, "is-disabled"],
        "isReadOnly": [516, "is-read-only"],
        "isRequired": [4, "is-required"],
        "errorMessage": [1537, "error-message"],
        "validationType": [1, "validation-type"],
        "isValid": [1540, "is-valid"],
        "isTextUpperCase": [516, "is-text-upper-case"],
        "placeholder": [513],
        "inputValue": [1537, "input-value"],
        "matchValue": [513, "match-value"],
        "shouldCloseOverlays": [4, "should-close-overlays"],
        "suggestionType": [1, "suggestion-type"],
        "dropdownOffsetWidth": [2, "dropdown-offset-width"],
        "clearOnSelection": [516, "clear-on-selection"],
        "isTracking": [4, "is-tracking"],
        "trackingData": [16],
        "parentOverlayContainerSelector": [513, "parent-overlay-container-selector"],
        "dataTestSuffix": [8, "data-test-suffix"],
        "isSearchBox": [4, "is-search-box"],
        "customNoResultsMessage": [1, "custom-no-results-message"],
        "clearButtonLabel": [1, "clear-button-label"],
        "namespaceI18n": [1, "namespace-i-1-8n"],
        "i18nKeys": [16],
        "componentType": [32],
        "hasInputFocus": [32],
        "hasMatches": [32],
        "hasExactMatch": [32],
        "isOverlayOpen": [32],
        "focusSource": [32],
        "open": [64],
        "close": [64],
        "toggleDisable": [64],
        "validate": [64],
        "setValue": [64],
        "validateForRequired": [64],
        "focusInput": [64]
    }, undefined, {
        "addButtonPrime": ["addButtonPrimeChanged"],
        "isOpen": ["isOpenChanged"],
        "isOverlayOpen": ["isOverlayOpenChanged"],
        "hasInputFocus": ["hasInputFocusChangedHandler"],
        "data": ["dataChangedHandler"],
        "initialStateData": ["initialStateDataChangedHandler"],
        "pillbox": ["pillboxChangedHandler"],
        "debounceTime": ["initDelayedSearch"],
        "throttleTime": ["initDelayedSearch"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bxf-type-ahead"];
    components.forEach(tagName => { switch (tagName) {
        case "bxf-type-ahead":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BxfTypeAhead$1);
            }
            break;
    } });
}

const BxfTypeAhead = BxfTypeAhead$1;
const defineCustomElement = defineCustomElement$1;

export { BxfTypeAhead, defineCustomElement };
